<div class="main-content">
	<div class="container-fluid">
		<div class="row tp-wrapper m-0 p-0">
			<div class="col-md-12 ">
				<div class="card ">
					<div class="card-header card-header-{{color}}-6 bank-rec-page-header">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()" aria-label="Back to General Ledger">arrow_back</mat-icon>
							<span>{{ title }}</span>
						</h4>
					</div>
					<div class="card-body bank-rec-page">

						<div class="bank-rec-tabbar">
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='rec'" (click)="activeTab='rec'">Reconciliation</button>
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='integrations'" (click)="setIntegrationsTab()">Bank Feed</button>
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='connections'" (click)="setConnectionsTab()">Connections</button>
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='files'" (click)="setStatementFilesTab()">Statement Files</button>
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='groups'" (click)="setGroupsTab()">Batch match</button>
							<button type="button" class="bank-rec-tab" [class.active]="activeTab==='ar'" (click)="setArTab()">AR receipts</button>
						</div>

						<div class="bank-rec-tabpane" [hidden]="activeTab !== 'rec'">
						<div class="bank-rec-filters-card">
						<!-- Row 1: Bank Account, Date Range, Load -->
						<div class="row bank-rec-filters-row align-items-start">
							<div class="col-lg-4 col-md-6 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Bank Account</mat-label>
									<mat-select [formControl]="selectedBankAccount">
										<mat-option *ngFor="let acc of bankAccounts" [value]="acc.accountcode">
											{{ acc.bankaccountname }} ({{ acc.accountcode }})
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-lg-5 col-md-8 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Date Range</mat-label>
									<mat-date-range-input [rangePicker]="dateRangePicker">
										<input matStartDate [formControl]="datefrom" placeholder="From">
										<input matEndDate [formControl]="dateto" placeholder="To">
									</mat-date-range-input>
									<mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
									<mat-date-range-picker #dateRangePicker></mat-date-range-picker>
								</mat-form-field>
							</div>
							<div class="col-lg-3 col-md-4 mb-2 d-flex align-items-center">
								<button
									mat-raised-button
									color="accent"
									class="bank-rec-load-btn"
									(click)="loadTransactions()"
									[disabled]="running"
								>
									<span *ngIf="running" class="d-inline-flex align-items-center">
										<svg class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</span>
									<span *ngIf="!running">Load</span>
								</button>
							</div>
						</div>

						<!-- Row 2: Warehouse, Type, AR/AP, Search, View + More filters -->
						<div class="row bank-rec-filters-row align-items-start">
							<div class="col-lg-3 col-md-6 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Warehouse</mat-label>
									<mat-select [formControl]="defaultlocation" multiple appSelectAll>
										<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
											{{ loc.locationname }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-lg-3 col-md-6 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Type</mat-label>
									<mat-select [formControl]="paymenttypefilter" multiple appSelectAll>
										<mat-option *ngFor="let cur of payment_methods" [value]="cur">
											{{ cur.paymentname }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-lg-2 col-md-4 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Ledger</mat-label>
									<mat-select [formControl]="arapLedgers" multiple appSelectAll>
										<mat-option value="ar">AR (receipts)</mat-option>
										<mat-option value="ap">AP (payments)</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-lg-2 col-md-5 mb-2">
								<mat-form-field appearance="outline" class="full-width">
									<mat-label>Search</mat-label>
									<input matInput type="text" placeholder="Search transactions" [formControl]="searchFilter" />
								</mat-form-field>
							</div>
							<div class="col-lg-2 col-md-3 mb-2 d-flex align-items-center justify-content-end bank-rec-toolbar-actions pt-1">
								<button
									mat-icon-button
									type="button"
									(click)="toggleGroupedView()"
									[matTooltip]="groupedView ? 'Switch to flat list' : 'Switch to grouped by day'"
									[attr.aria-label]="groupedView ? 'Flat list' : 'Grouped by day'"
								>
									<mat-icon>{{ groupedView ? 'view_list' : 'calendar_view_day' }}</mat-icon>
								</button>
							</div>
						</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="bank-rec-summary-section mt-3">
									<div class="bank-rec-summary-header">
										<div class="bank-rec-summary-title">Bank Reconciliation</div>
										<div class="bank-rec-summary-actions">
											<button
												mat-stroked-button
												type="button"
												class="bank-rec-bank-journal-btn"
												[disabled]="!selectedBankAccount.value || running"
												matTooltip="Post a two-line GL journal: this bank account and an offset account you choose (balanced)"
												(click)="openBankGlJournalDialog()"
											>
												<mat-icon>account_balance</mat-icon>
												Bank GL journal
											</button>
											<button
												mat-stroked-button
												type="button"
												class="bank-rec-unlock-locked-btn"
												[disabled]="!hasUnlockableLockedInSession() || unlockingAllLocked || lockingAllCleared || running"
												matTooltip="Unlock every loaded line that is locked (same as row unlock, for the whole list)"
												(click)="unlockAllLockedInSession()"
											>
												<mat-icon>lock_open</mat-icon>
												Unlock locked
											</button>
											<button
												mat-stroked-button
												type="button"
												color="primary"
												class="bank-rec-lock-cleared-btn"
												[disabled]="!hasLockableClearedInSession() || lockingAllCleared || unlockingAllLocked || running"
												matTooltip="Lock every loaded line that has a cleared amount"
												(click)="lockAllClearedInSession()"
											>
												<mat-icon>lock</mat-icon>
												Lock cleared
											</button>
										</div>
									</div>

									<ng-container *ngIf="selectedBankAccount.value; else bankRecNoAccount">

										<!-- Rec panels row -->
										<div class="bank-rec-summary-grid bank-rec-summary-grid--panels">
											<div class="bank-rec-summary-panel bank-rec-summary-panel--stmt">
												<div class="bank-rec-summary-panel-title">Statement balance</div>
												<mat-form-field appearance="outline" class="bank-rec-summary-panel-field full-width" subscriptSizing="dynamic">
													<input matInput type="number" step="0.01" [formControl]="statementBalance" placeholder="0.00" />
													<span matPrefix>$&nbsp;</span>
												</mat-form-field>
												<div class="bank-rec-summary-panel-hint">Saved on this device for this bank.</div>
											</div>
											<div class="bank-rec-summary-panel bank-rec-summary-panel--gl" aria-live="polite">
												<div class="bank-rec-summary-panel-title">GL book balance</div>
												<div class="bank-rec-summary-panel-value">{{ glBookBalance != null ? (glBookBalance | currency) : '—' }}</div>
												<div class="bank-rec-summary-panel-sub">{{ glBookChartCaption }}</div>
												<div class="bank-rec-summary-panel-sub" *ngIf="glBookPeriod != null">Period {{ glBookPeriod }}</div>
												<div class="bank-rec-summary-panel-error text-danger" *ngIf="glBookLoadError">Could not load GL.</div>
											</div>
											<div class="bank-rec-summary-panel">
												<div class="bank-rec-summary-panel-title">Cleared total</div>
												<div class="bank-rec-summary-panel-value">{{ clearedTotal | currency }}</div>
												<div class="bank-rec-summary-panel-hint">Items marked cleared below.</div>
											</div>
											<div
												class="bank-rec-summary-panel"
												[ngClass]="{ 'bank-rec-panel-overage': hasStatementBalance() && variance > 0, 'bank-rec-panel-shortage': hasStatementBalance() && variance < 0, 'bank-rec-panel-even': hasStatementBalance() && variance === 0 }"
											>
												<div class="bank-rec-summary-panel-title">{{ hasStatementBalance() ? (variance >= 0 ? 'Overage' : 'Shortage') : 'Variance' }}</div>
												<div class="bank-rec-summary-panel-value bank-rec-summary-panel-value--variance">{{ hasStatementBalance() ? (variance | currency) : '—' }}</div>
												<div class="bank-rec-summary-panel-hint">{{ hasStatementBalance() ? 'Statement − cleared.' : 'Enter the statement balance to compare.' }}</div>
											</div>
										</div>

										<!-- Session totals row -->
										<div class="bank-rec-session-totals">
											<div class="bank-rec-session-total-item">
												<span class="bank-rec-session-total-label">Total payments</span>
												<span class="bank-rec-session-total-value">{{ total_pay | currency }}</span>
											</div>
											<div class="bank-rec-session-total-item">
												<span class="bank-rec-session-total-label">Credit card</span>
												<span class="bank-rec-session-total-value">{{ cctotal | currency }}</span>
											</div>
											<div class="bank-rec-session-total-item">
												<span class="bank-rec-session-total-label">Total discount</span>
												<span class="bank-rec-session-total-value">{{ total_discount | currency }}</span>
											</div>
										</div>

										</ng-container>
									<ng-template #bankRecNoAccount>
										<p class="bank-rec-summary-empty text-muted small mb-0">Select a bank account to enter the statement balance and compare to the GL.</p>
									</ng-template>
								</div>
							</div>

							<div class="col-12">

								<!-- Transaction list toolbar -->
								<div class="bank-rec-list-toolbar">
									<mat-slide-toggle
										[formControl]="showCleared"
										(change)="toggleClearView()"
										class="bank-rec-show-cleared-toggle"
									>
										Show cleared
									</mat-slide-toggle>
									<span class="bank-rec-show-cleared-note" *ngIf="!showCleared.value">
										<mat-icon class="bank-rec-show-cleared-note-icon">info_outline</mat-icon>
										Cleared items are hidden — session Lock / Unlock still applies to all loaded lines.
									</span>
								</div>

								<div *ngIf="groupedView" class="grouped-transactions-container">
									<div *ngFor="let dateGroup of groupedTransactions; trackBy: trackByDateGroup" class="date-group">
										<div class="date-group-header-bar">
											<div
												class="date-group-lhs"
												role="button"
												tabindex="0"
												(click)="toggleDateExpanded(dateGroup)"
												(keydown.enter)="toggleDateExpanded(dateGroup)"
												(keydown.space)="$event.preventDefault(); toggleDateExpanded(dateGroup)"
											>
												<mat-icon class="date-expand-icon">{{ dateGroup.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
												<mat-checkbox
													class="date-group-checkbox"
													[checked]="dateGroup.allCleared"
													[indeterminate]="dateGroup.partiallyCleared"
													(change)="onDayBulkChange(dateGroup, $event.checked)"
													matTooltip="Mark all unlocked transactions for this day cleared"
													(click)="$event.stopPropagation()"
												></mat-checkbox>
												<button
													mat-icon-button
													type="button"
													class="date-lock-btn"
													[disabled]="!hasLockableClearedTransactions(dateGroup)"
													matTooltip="Lock cleared amounts for this day"
													(click)="lockDayClearedAmounts(dateGroup); $event.stopPropagation()"
												>
													<mat-icon>lock</mat-icon>
												</button>
												<button
													mat-icon-button
													type="button"
													class="date-unlock-btn"
													[disabled]="!hasUnlockableLockedTransactions(dateGroup)"
													matTooltip="Unlock locked lines for this day"
													(click)="unlockDayLockedAmounts(dateGroup); $event.stopPropagation()"
												>
													<mat-icon>lock_open</mat-icon>
												</button>
												<span class="date-group-date">{{ dateGroup.dateFmt }}</span>
												<span class="date-group-total">{{ dateGroup.total | currency }}</span>
											</div>
											<div class="date-group-types-strip" (click)="$event.stopPropagation()">
												<div *ngFor="let tg of dateGroup.types" class="bank-rec-type-chip">
													<mat-checkbox
														class="bank-rec-type-chip-checkbox"
														[checked]="tg.allCleared"
														[indeterminate]="tg.partiallyCleared"
														(change)="onTypeBulkChange(tg, dateGroup, $event.checked)"
														[matTooltip]="'Mark all ' + tg.type + ' cleared for this day'"
														(click)="$event.stopPropagation()"
													></mat-checkbox>
													<span class="bank-rec-type-chip-name">{{ tg.type }}</span>
													<span class="bank-rec-type-chip-total">{{ tg.total | currency }}</span>
												</div>
											</div>
										</div>

										<div *ngIf="dateGroup.expanded" class="date-tree">
											<div *ngFor="let typeGroup of dateGroup.types" class="tree-type-row">
												<div class="tree-type-header" (click)="toggleTypeDetail(typeGroup)">
													<mat-checkbox
														class="tree-type-checkbox"
														[checked]="typeGroup.allCleared"
														[indeterminate]="typeGroup.partiallyCleared"
														(change)="onTypeBulkChange(typeGroup, dateGroup, $event.checked)"
														(click)="$event.stopPropagation()"
														[matTooltip]="'Mark all ' + typeGroup.type + ' cleared'"
													></mat-checkbox>
													<span class="tree-type-name">{{ typeGroup.type }}</span>
													<span class="tree-type-total">{{ typeGroup.total | currency }}</span>
													<span class="tree-type-spacer"></span>
													<mat-icon class="tree-type-arrow">{{ typeGroup.detailExpanded ? 'expand_less' : 'keyboard_arrow_down' }}</mat-icon>
												</div>
												<div *ngIf="typeGroup.detailExpanded" class="tree-type-body">
													<div class="transactions-container-inner">
														<div class="transaction-header">
															<span>Transaction #</span>
															<span>Date</span>
															<span>Debtor #</span>
															<span>Reference</span>
															<span>Amount</span>
															<span>Discount</span>
															<span>Currency</span>
															<span>Allocation</span>
															<span>Check #</span>
															<span>Bank Type</span>
															<span>Name</span><span>Placed By</span><span>Location</span>
															<span>Cleared</span>
															<span></span>
														</div>
														<div *ngFor="let transaction of typeGroup.transactions; trackBy: trackByTransaction" class="transaction-row" [class.partial]="transaction.amountCleared && transaction.amountCleared != transaction.ovamount && !transaction.isCleared " [class.bank-rec-row-locked]="transaction.clearedLocked">
															<span [class.cleared]="transaction.isCleared">{{ transaction.transno }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.trandate }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.debtorno }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.reference }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.ovamount | currency:transaction.currcode }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.ovdiscount | currency:transaction.currcode }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.currcode }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.alloc | currency:transaction.currcode }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.checknum }}</span>
															<span [class.cleared]="transaction.isCleared">{{ transaction.banktranstype }}</span>
															<span [class.cleared]="transaction.isCleared"><span *ngIf="showLedgerColumn()" class="ledger-badge">{{ ledgerLabel(transaction) }}</span> {{ transaction.name }}</span><span [class.cleared]="transaction.isCleared">{{ transaction.placedby }}</span><span [class.cleared]="transaction.isCleared">{{ locName(transaction.paylocation) }}</span>
															<span [class.cleared]="transaction.isCleared" [ngClass]="transaction.isSelected ? 'editable-amount' : ''">
																<span *ngIf="!transaction.isSelected && !transaction.clearedLocked" class="editable-amount" (click)="$event.stopPropagation(); toggleEdit(transaction)">
																	{{ transaction.amountCleared | currency }}
																	<i class="fa fa-edit"></i>
																</span>
																<span *ngIf="!transaction.isSelected && transaction.clearedLocked">
																	{{ transaction.amountCleared | currency }}
																</span>

																<ng-container *ngIf="transaction.isSelected">
																	<div class="editable-container">
																		<div class="editable-row">
																			<input id="amount-input-g-{{ transaction.banktransid }}" type="number" [formControl]="temporaryAmount" class="editable-input" placeholder="Enter amount" />
																		</div>
																		<div class="editable-actions">
																			<button class="editable-save-button" type="button" (click)="savePartial(transaction)">
																				<i class="fa fa-save"></i>
																			</button>
																			<button class="editable-cancel-button" type="button" (click)="toggleEdit(transaction)">
																				<i class="fa fa-close"></i>
																			</button>
																		</div>
																	</div>
																	</ng-container>
															</span>

															<span *ngIf="!transaction.clearedLocked" class="bank-rec-clear-actions" (click)="$event.stopPropagation()">
																<div class="custom-checkbox-wrapper">
																	<label [for]="'cleared-g-' + transaction.banktransid" class="custom-checkbox-label">
																		<div class="amount-display"></div>
																	</label>
																	<input type="checkbox" [id]="'cleared-g-' + transaction.banktransid" [checked]="transaction.isCleared" class="custom-checkbox" (change)="onRowClearChange(transaction, $event)" />
																</div>
																<button mat-icon-button type="button" class="bank-rec-lock-btn" [disabled]="!isTransactionCleared(transaction)" matTooltip="Lock cleared amount" (click)="lockClearedAmount(transaction); $event.stopPropagation()">
																	<mat-icon>lock</mat-icon>
																</button>
															</span>
															<span *ngIf="transaction.clearedLocked" class="bank-rec-locked-actions">
																<mat-icon matTooltip="Saved — locked">lock</mat-icon>
																<button mat-icon-button type="button" class="bank-rec-unlock-btn" matTooltip="Unlock to edit cleared amount" (click)="unlockClearedLock(transaction); $event.stopPropagation()">
																	<mat-icon>lock_open</mat-icon>
																</button>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div *ngIf="!groupedView" class="transactions-container">
									<div class="transaction-header">
										<span>Transaction #</span>
										<span>Date</span>
										<span>Debtor #</span>
										<span>Reference</span>
										<span>Amount</span>
										<span>Discount</span>
										<span>Currency</span>
										<span>Allocation</span>
										<span>Check #</span>
										<span>Bank Type</span>
										<span>Name</span><span>Placed By</span><span>Location</span>
										<span>Cleared</span>
										<span></span>
									</div>
									<div *ngFor="let transaction of filteredTransactions;trackBy: trackByTransaction" class="transaction-row" [class.partial]="transaction.amountCleared && transaction.amountCleared != transaction.ovamount && !transaction.isCleared " [class.bank-rec-row-locked]="transaction.clearedLocked">
										<span [class.cleared]="transaction.isCleared">{{ transaction.transno }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.trandate }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.debtorno }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.reference }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.ovamount | currency:transaction.currcode }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.ovdiscount | currency:transaction.currcode }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.currcode }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.alloc | currency:transaction.currcode }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.checknum }}</span>
										<span [class.cleared]="transaction.isCleared">{{ transaction.banktranstype }}</span>
										<span [class.cleared]="transaction.isCleared"><span *ngIf="showLedgerColumn()" class="ledger-badge">{{ ledgerLabel(transaction) }}</span> {{ transaction.name }}</span><span [class.cleared]="transaction.isCleared">{{ transaction.placedby }}</span><span [class.cleared]="transaction.isCleared">{{ locName(transaction.paylocation) }}</span>
										<span [class.cleared]="transaction.isCleared" [ngClass]="transaction.isSelected ? 'editable-amount' : ''">
											<span *ngIf="!transaction.isSelected && !transaction.clearedLocked" class="editable-amount" (click)="toggleEdit(transaction)">
												{{ transaction.amountCleared | currency }}
												<i class="fa fa-edit"></i>
											</span>
											<span *ngIf="!transaction.isSelected && transaction.clearedLocked">
												{{ transaction.amountCleared | currency }}
											</span>

											<ng-container *ngIf="transaction.isSelected">
												<div class="editable-container">
													<div class="editable-row">
														<input id="amount-input-{{ transaction.transno }}" type="number" [formControl]="temporaryAmount" class="editable-input" placeholder="Enter amount" />
													</div>
													<div class="editable-actions">
														<button class="editable-save-button" type="button" (click)="savePartial(transaction)">
															<i class="fa fa-save"></i>
														</button>
														<button class="editable-cancel-button" type="button" (click)="toggleEdit(transaction)">
															<i class="fa fa-close"></i>
														</button>
													</div>
												</div>
												</ng-container>
										</span>

										<span *ngIf="!transaction.clearedLocked" class="bank-rec-clear-actions">
											<div class="custom-checkbox-wrapper">
												<label for="cleared-{{ transaction.id }}" class="custom-checkbox-label">
													<div class="amount-display"></div>
												</label>
												<input type="checkbox" id="cleared-{{ transaction.id }}" [checked]="transaction.isCleared" class="custom-checkbox" (change)="onRowClearChange(transaction, $event)" />
											</div>
											<button mat-icon-button type="button" class="bank-rec-lock-btn" [disabled]="!isTransactionCleared(transaction)" matTooltip="Lock cleared amount" (click)="lockClearedAmount(transaction); $event.stopPropagation()">
												<mat-icon>lock</mat-icon>
											</button>
										</span>
										<span *ngIf="transaction.clearedLocked" class="bank-rec-locked-actions">
											<mat-icon matTooltip="Saved — locked">lock</mat-icon>
											<button mat-icon-button type="button" class="bank-rec-unlock-btn" matTooltip="Unlock to edit cleared amount" (click)="unlockClearedLock(transaction); $event.stopPropagation()">
												<mat-icon>lock_open</mat-icon>
											</button>
										</span>
									</div>
								</div>
							</div>
						</div>
						</div><!-- /rec tabpane -->

						<!-- Integrations tab -->
						<div class="bank-rec-tabpane bank-rec-integrations" [hidden]="activeTab !== 'integrations'">
							<div class="sf-card" [class.sf-card-expanded]="sfExpanded" role="region" aria-label="Bank feed reconciliation workspace">
								<div class="sf-head">
									<h5 class="mb-0">SimpleFIN bank feed</h5>
									<span class="sf-status" [class.on]="sf.connected">{{ sf.connected ? 'Connected' : 'Not connected' }}</span>
									<span class="sf-spacer"></span>
									<button type="button" class="sf-expand-btn" (click)="toggleSfExpanded()" [attr.aria-pressed]="sfExpanded" [attr.aria-label]="sfExpanded ? 'Exit expanded reconciliation workspace' : 'Expand reconciliation workspace'">
										<mat-icon aria-hidden="true">{{ sfExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
										<span>{{ sfExpanded ? 'Exit expanded' : 'Expand workspace' }}</span>
									</button>
								</div>

								<div *ngIf="sf.loaded && !sf.connected" class="sf-connect">
									<p class="text-muted small mb-2">SimpleFIN isn't connected — statements dropped on <a href="javascript:void(0)" (click)="setStatementFilesTab()">Statement Files</a> still work below. Connect SimpleFIN on <a href="javascript:void(0)" (click)="setConnectionsTab()">Connections</a> for live bank sync too.</p>
								</div>

								<div *ngIf="sf.loaded">
									<div class="sf-toolbar">
										<span class="sf-import-window" role="group" aria-label="Viewing window">
											<span class="sf-import-window-label">View</span>
											<button *ngFor="let d of sfImportWindows" type="button" class="sf-chip sf-chip-window" [class.on]="sfImportWindowActive(d)" (click)="sfSetImportWindow(d)" [matTooltip]="'Show the last ' + d + ' days in both panes'">{{ d === 365 ? '1y' : d + 'd' }}</button>
										</span>
										<mat-form-field appearance="outline" class="sf-daterange" matTooltip="Pick any fixed range — the day chips above are always relative to today, so they can't show a past period like a specific statement month">
											<mat-label>or a fixed range</mat-label>
											<mat-date-range-input [rangePicker]="sfIntRangePicker">
												<input matStartDate [formControl]="datefrom" placeholder="From">
												<input matEndDate [formControl]="dateto" placeholder="To" (dateChange)="sfApplyCustomRange()">
											</mat-date-range-input>
											<mat-datepicker-toggle matSuffix [for]="sfIntRangePicker"></mat-datepicker-toggle>
											<mat-date-range-picker #sfIntRangePicker></mat-date-range-picker>
										</mat-form-field>
										<span class="sf-spacer"></span>
										<button class="btn btn-outline-secondary btn-sm" (click)="loadSimplefinFeed()" [disabled]="sfFeedLoading">{{ sfFeedLoading ? 'Loading…' : 'Load imported' }}</button>
										<button class="btn btn-success btn-sm" (click)="simplefinSync()" [disabled]="sf.syncing || !sf.connected" [matTooltip]="sf.connected ? '' : 'Connect SimpleFIN on the Connections tab first'">{{ sf.syncing ? 'Importing…' : 'Import from bank' }}</button>
										<button class="btn btn-primary btn-sm" (click)="autoMatchSimplefin()" [disabled]="sfMatching || !sf.transactions.length">{{ sfMatching ? 'Matching…' : 'Auto-match' }}</button>
										<button class="btn btn-outline-primary btn-sm" (click)="aiMatchSimplefin()" [disabled]="sfAiMatching || !sfUnmatchedCount()">{{ sfAiMatching ? 'AI matching…' : 'AI match (' + sfUnmatchedCount() + ')' }}</button>
										<!-- Exports follow the status chip below, so each chip has its own export
										     without needing four pairs of buttons. -->
										<button class="btn btn-outline-secondary btn-sm" (click)="sfExportFeed('xlsx')" [disabled]="sfExporting || !sfBankRows().length" [matTooltip]="'Export the ' + sfChipLabel() + ' rows to Excel'">{{ sfExporting === 'xlsx' ? 'Building…' : 'XLSX' }}</button>
										<button class="btn btn-outline-secondary btn-sm" (click)="sfExportFeed('pdf')" [disabled]="sfExporting || !sfBankRows().length" [matTooltip]="'Export the ' + sfChipLabel() + ' rows to PDF'">{{ sfExporting === 'pdf' ? 'Building…' : 'PDF' }}</button>
									</div>

									<ng-container>
										<!-- Focused selected transaction modal; workspace remains visible underneath. -->
										<ng-template #sfMatchModal let-modal>
										<div class="sf-match-detail sf-match-detail-modal" *ngIf="sfMatchGroup().length && sfMatchGroup() as group">
											<div class="sf-match-detail-head">
												<div>
													<small><span class="sf-modal-kicker-dot"></span> {{ group.length > 1 ? ('Matching ' + group.length + ' bank lines together') : 'Bank transaction review' }}</small>
													<strong *ngIf="group.length === 1">{{ group[0].description || 'No bank description' }}</strong>
													<strong *ngIf="group.length > 1">{{ group.length }} bank lines · {{ sfMatchGroupSum() | currency }}</strong>
												</div>
												<div class="sf-modal-actions">
													<button *ngIf="group.length === 1 && !group[0].matched && !group[0].ignored && group[0].amount < 0" type="button" class="btn btn-primary btn-sm sf-post-allocate-btn" (click)="sfPostSelectedBank()">Post payment / allocate</button>
												<button *ngIf="group.length === 1 && !group[0].matched && !group[0].ignored && group[0].amount > 0" type="button" class="btn btn-primary btn-sm sf-post-allocate-btn" (click)="sfReceiptSelectedBank()">Post customer receipt</button>
													<button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleSfMatchExpanded()">{{ sfMatchExpanded ? 'Restore' : 'Expand' }}</button>
													<button type="button" class="btn btn-outline-secondary btn-sm" (click)="modal.dismiss('close')">Close</button>
												</div>
											</div>
											<div class="sf-match-fields" *ngIf="group.length === 1">
												<div><small>Posted</small><strong>{{ group[0].posted }}</strong></div>
												<div><small>Amount</small><strong [class.sf-neg]="group[0].amount < 0">{{ group[0].amount | currency }}</strong></div>
												<div><small>Status</small><strong>{{ group[0].pending ? 'Pending' : 'Posted' }}</strong></div>
												<div><small>Bank reference</small><strong>{{ group[0].sf_id }}</strong></div>
											</div>
											<div class="sf-group-lines" *ngIf="group.length > 1">
												<div class="sf-group-line" *ngFor="let g of group">
													<span class="sf-group-date">{{ g.posted }}</span>
													<span class="sf-group-desc">{{ g.description }}</span>
													<strong class="sf-group-amt" [class.sf-neg]="g.amount < 0">{{ g.amount | currency }}</strong>
													<button type="button" class="btn btn-link btn-sm sf-action sf-action-muted" (click)="sfToggleBankSel(g)">Remove</button>
												</div>
											</div>
											<ng-container *ngIf="sfPossibleMatches() as candidates">
												<div class="sf-candidates-title-row">
													<div class="sf-candidates-head">Possible ERP matches <small>{{ candidates.length }} shown · amounts compare against {{ sfMatchGroupSum() | currency }}</small></div>
												</div>
												<div class="sf-candidate-tools">
													<label class="sf-candidate-search"><span>Search ERP candidates</span><input type="search" class="form-control" placeholder="Customer/vendor, account, reference, amount…" [(ngModel)]="sfCandidateSearch" [ngModelOptions]="{standalone:true}"></label>
													<label><span>Evidence</span><select class="form-control" [(ngModel)]="sfCandidateKind" [ngModelOptions]="{standalone:true}"><option value="all">Amount or name</option><option value="exact">Exact amount</option><option value="name">Name similar</option><option value="any">Show all (combine)</option></select></label>
													<label><span>Days apart</span><select class="form-control" [(ngModel)]="sfCandidateDays" [ngModelOptions]="{standalone:true}"><option [ngValue]="0">Any loaded date</option><option [ngValue]="5">Within 5 days</option><option [ngValue]="14">Within 14 days</option><option [ngValue]="30">Within 30 days</option></select></label>
													<label><span>Sort</span><select class="form-control" [(ngModel)]="sfCandidateSort" [ngModelOptions]="{standalone:true}"><option value="recommended">Recommended</option><option value="closest">Closest date</option><option value="amount">Closest amount</option><option value="name">Name</option></select></label>
												</div>
												<div class="sf-candidate-empty" *ngIf="!candidates.length">No amount- or name-similar unmatched ERP transactions are loaded in this range. Try Evidence → “Show all (combine)”.</div>
												<div class="sf-candidates" *ngIf="candidates.length">
												<div class="sf-candidate" *ngFor="let candidate of candidates" [class.sf-candidate-exact]="candidate.exactAmount" [class.sf-candidate-selected]="sfIsErpSel(candidate.row)">
													<label class="sf-candidate-check" (click)="$event.stopPropagation()">
														<input type="checkbox" [checked]="sfIsErpSel(candidate.row)" (change)="sfToggleErpSel(candidate.row)" [attr.aria-label]="'Combine ' + (candidate.row.name || 'ERP transaction')" />
													</label>
													<span class="sf-candidate-date">{{ candidate.row.trandate }}</span>
													<span class="sf-candidate-name">
														<strong>{{ candidate.row.name || 'Unnamed ERP transaction' }}</strong>
														<small>{{ candidate.row.typename || candidate.row.type }} · {{ candidate.row.debtorno }}<span *ngIf="candidate.row.reference"> · {{ candidate.row.reference }}</span></small>
													</span>
													<span class="sf-candidate-evidence">
														<small class="sf-evidence-date">{{ candidate.daysApart === 9999 ? 'Date unavailable' : (candidate.daysApart + ' day' + (candidate.daysApart === 1 ? '' : 's') + ' apart') }}</small>
														<small *ngIf="candidate.exactAmount" class="sf-evidence-exact">Exact amount</small>
														<small *ngIf="candidate.nameScore > 0" class="sf-evidence-name">Name similar</small>
													</span>
													<strong class="sf-candidate-amount" [class.sf-neg]="candidate.row.amount < 0">{{ candidate.row.amount | currency }}</strong>
											<button *ngIf="!sfSelErp.length" type="button" class="btn btn-sm" [class.btn-primary]="candidate.exactAmount" [class.btn-outline-warning]="!candidate.exactAmount" (click)="sfMatchCandidate(candidate)" [matTooltip]="candidate.exactAmount ? '' : 'Keep ERP unchanged and accept the bank/ERP difference'">{{ candidate.exactAmount ? 'Match' : 'Match + ignore difference' }}</button>
												</div>
												</div>
												<!-- Combine footer: several ERP postings settle the bank side. -->
												<div class="sf-combine-bar" *ngIf="sfSelErp.length">
													<div class="sf-combine-sums">
														<span>Bank <strong [class.sf-neg]="sfMatchGroupSum() < 0">{{ sfMatchGroupSum() | currency }}</strong></span>
														<span>ERP selected ({{ sfSelErp.length }}) <strong [class.sf-neg]="sfSelErpSum() < 0">{{ sfSelErpSum() | currency }}</strong></span>
														<span [class.sf-combine-ok]="sfCanCompleteCombo()" [class.sf-combine-off]="!sfCanCompleteCombo()">
															{{ sfCanCompleteCombo() ? 'Sums tie ✓' : ('Off by ' + (sfComboDiff() | currency)) }}
														</span>
													</div>
													<div class="sf-combine-actions">
												<button type="button" class="btn btn-outline-secondary btn-sm" (click)="sfSelErp = []">Clear selection</button>
												<button *ngIf="sfCanAcceptComboVariance()" type="button" class="btn btn-outline-warning btn-sm" (click)="sfCompleteComboWithVariance()">Match + ignore {{ sfComboDiff() | currency }} difference</button>
												<button type="button" class="btn btn-primary btn-sm" [disabled]="!sfCanCompleteCombo()" (click)="sfCompleteCombo()">Match {{ group.length }} bank ↔ {{ sfSelErp.length }} ERP</button>
													</div>
												</div>
												</ng-container>
										</div>
										</ng-template>

										<!-- Status filter chips -->
										<div class="sf-chips">
											<button type="button" class="sf-chip" [class.on]="sfStatusFilter === 'unmatched'" [attr.aria-pressed]="sfStatusFilter === 'unmatched'" (click)="sfStatusFilter = 'unmatched'">Work queue · hide matched</button>
											<button type="button" class="sf-chip" [class.on]="sfStatusFilter === 'all'" [attr.aria-pressed]="sfStatusFilter === 'all'" (click)="sfStatusFilter = 'all'">All rows</button>
											<button type="button" class="sf-chip" [class.on]="sfStatusFilter === 'matched'" [attr.aria-pressed]="sfStatusFilter === 'matched'" (click)="sfStatusFilter = 'matched'">Matched only</button>
											<button type="button" class="sf-chip" [class.on]="sfStatusFilter === 'ignored'" [attr.aria-pressed]="sfStatusFilter === 'ignored'" (click)="sfStatusFilter = 'ignored'">Ignored</button>
											<span class="sf-spacer"></span>
											<span class="sf-diff" [class.sf-diff-zero]="sfRecDiff() === 0">Bank − ERP: <strong>{{ sfRecDiff() | currency }}</strong></span>
										</div>
										<div class="sf-subset-tools">
											<label>From <input type="date" class="form-control form-control-sm" [(ngModel)]="sfSubsetFrom" [ngModelOptions]="{standalone:true}"></label>
											<label>To <input type="date" class="form-control form-control-sm" [(ngModel)]="sfSubsetTo" [ngModelOptions]="{standalone:true}"></label>
											<label>Direction
												<select class="form-control form-control-sm" [(ngModel)]="sfDirection" [ngModelOptions]="{standalone:true}">
													<option value="all">Money in + out</option><option value="in">Money in</option><option value="out">Money out</option>
												</select>
											</label>
											<label>Amounts
												<select class="form-control form-control-sm" [(ngModel)]="sfAmountOccurrence" [ngModelOptions]="{standalone:true}">
													<option value="all">All amounts</option><option value="single">Singles only</option><option value="repeated">Repeated only</option>
												</select>
											</label>
											<label>Sort
												<select class="form-control form-control-sm" [(ngModel)]="sfSort" [ngModelOptions]="{standalone:true}">
													<option value="date-desc">Newest day first</option><option value="date-asc">Oldest day first</option><option value="amount-desc">Amount high → low</option><option value="amount-asc">Amount low → high</option><option value="name">Name / description</option>
												</select>
											</label>
											<button type="button" class="btn btn-outline-secondary btn-sm" (click)="sfResetSubset()">Reset subset</button>
										</div>

										<!-- Side-by-side workspace -->
										<div class="sf-workspace">
											<!-- Bank pane -->
											<div class="sf-pane">
												<div class="sf-pane-summary" *ngIf="sfBankStats() as bs">
													<button type="button" class="sf-pane-total sf-sum-in" [class.active]="sfSummaryFilterActive('received')" (click)="sfApplySummaryFilter('received')"><small>Bank received</small><strong>{{ bs.received | currency }} <span>({{ bs.receivedCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-out" [class.active]="sfSummaryFilterActive('paid')" (click)="sfApplySummaryFilter('paid')"><small>Bank paid out</small><strong>{{ bs.paidOut | currency }} <span>({{ bs.paidOutCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-ok" [class.active]="sfSummaryFilterActive('matched')" (click)="sfApplySummaryFilter('matched')"><small>Bank matched</small><strong>{{ bs.matchedTotal | currency }} <span>({{ bs.matchedCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-warn" [class.active]="sfSummaryFilterActive('unmatched')" (click)="sfApplySummaryFilter('unmatched')"><small>Bank unmatched</small><strong>{{ bs.openTotal | currency }} <span>({{ bs.openCount }})</span></strong></button>
												</div>
												<div class="sf-pane-head">
													<div class="sf-pane-title">Bank statement <small>({{ sfBankRows().length }})</small></div>
													<input class="form-control form-control-sm sf-pane-search" type="search" aria-label="Search bank statement transactions" placeholder="Search bank…" [(ngModel)]="sfBankSearch" [ngModelOptions]="{standalone: true}" />
												</div>
												<!-- Group bar: several bank lines matched together to one ERP posting. -->
												<div class="sf-group-bar" *ngIf="sfSelBank.length">
													<span class="sf-pairing-pulse"></span>
													<span><strong>{{ sfSelBank.length }}</strong> bank line{{ sfSelBank.length === 1 ? '' : 's' }} · <strong [class.sf-neg]="sfSelBankSum() < 0">{{ sfSelBankSum() | currency }}</strong></span>
													<span class="sf-group-hint">Click the ERP posting that settles the total, or find one →</span>
													<span class="sf-spacer"></span>
													<button type="button" class="btn btn-primary btn-sm" (click)="sfOpenGroupMatch()">Find match</button>
													<button type="button" class="btn btn-outline-secondary btn-sm" (click)="sfClearBankSel()">Clear</button>
												</div>
												<div class="sf-pane-body">
													<div *ngIf="!sfBankRows().length" class="sf-pane-empty">No bank transactions for this account, range, and filter.</div>
													<div *ngFor="let s of sfBankRows()"
														class="sf-row sf-row-bank"
														[id]="s.matched ? 'sf-bank-' + s.matchBankTransId : null"
												[class.sf-row-matched]="s.matched || s.feedPosted"
												[class.sf-row-open]="!s.matched && !s.ignored && !s.feedPosted"
														[class.sf-row-ignored]="s.ignored"
														[class.sf-row-selected]="sfSelectedBank === s || sfIsBankSel(s)"
														[class.sf-hl]="sfBankHl(s)"
														(mouseenter)="sfSetHoverBank(s)"
														(mouseleave)="sfSetHoverBank(null)"
														(click)="sfBankRowClick(s)">
														<span class="sf-row-check" (click)="$event.stopPropagation()">
															<input *ngIf="!s.matched && !s.ignored && !s.feedPosted" type="checkbox" [checked]="sfIsBankSel(s)" (change)="sfToggleBankSel(s)" [attr.aria-label]="'Select bank line ' + (s.description || s.sf_id) + ' for group matching'" />
														</span>
														<span class="sf-row-date">{{ s.posted }}</span>
														<span class="sf-row-desc" [matTooltip]="s.description">
															<span class="sf-row-descmain">{{ s.description }}</span>
															<small class="sf-row-meta"><span class="sf-row-acct">{{ sfAcctChip(s.erp_bankact) }}</span></small>
														</span>
														<span class="sf-row-amt" [class.sf-neg]="s.amount < 0">{{ s.amount | currency }}</span>
														<span class="sf-row-state">
															<span *ngIf="s.matched" class="sf-matched" [matTooltip]="s.matchReason || ''">✓ {{ s.matchTransno }}<span *ngIf="s.matchAi" class="sf-ai-tag">AI</span></span>
															<span *ngIf="!s.matched && !s.ignored && !s.feedPosted" class="sf-open-dot" matTooltip="Not matched to an ERP transaction"></span>
															<span *ngIf="s.ignored" class="sf-ignored-tag">ignored</span>
															<span *ngIf="s.feedPosted" class="sf-matched">✓ journal {{ s.feedPostTransno }}</span>
															<span *ngIf="s.pending" class="sf-pending">pending</span>
														</span>
														<span class="sf-row-actions" (click)="$event.stopPropagation()">
															<button *ngIf="!s.matched && !s.ignored && !s.feedPosted && s.amount < 0" type="button" class="btn btn-link btn-sm sf-action sf-action-post" (click)="sfOpenPosting(s)">Post</button>
														<button *ngIf="!s.matched && !s.ignored && !s.feedPosted && s.amount > 0" type="button" class="btn btn-link btn-sm sf-action sf-action-post" (click)="sfOpenReceipt(s)" matTooltip="Post a customer receipt for this deposit and match it">Post</button>
														<button *ngIf="!s.matched && !s.ignored && !s.feedPosted" type="button" class="btn btn-link btn-sm sf-action sf-action-muted" (click)="sfOpenJournal(s)" matTooltip="Post a two-line GL journal (bank fee, interest) and retain the ERP journal reference">Journal</button>
															<button *ngIf="s.matched" type="button" class="btn btn-link btn-sm sf-action sf-action-danger" (click)="sfUnmatch(s)">Unmatch</button>
															<button *ngIf="!s.matched && !s.feedPosted" type="button" class="btn btn-link btn-sm sf-action sf-action-muted" (click)="sfToggleIgnore(s)">{{ s.ignored ? 'Unignore' : 'Ignore' }}</button>
														</span>
													</div>
												</div>
												<div class="sf-pane-foot">
													<span>{{ sfBankRows().length }} shown</span>
													<span class="sf-spacer"></span>
													<span>Shown net <strong [class.sf-neg]="sfRowsTotal(sfBankRows()) < 0">{{ sfRowsTotal(sfBankRows()) | currency }}</strong></span>
												</div>
											</div>

											<!-- ERP pane -->
											<div class="sf-pane">
												<div class="sf-pane-summary" *ngIf="sfErpStats() as es">
													<button type="button" class="sf-pane-total sf-sum-in" [class.active]="sfSummaryFilterActive('received')" (click)="sfApplySummaryFilter('received')"><small>ERP received</small><strong>{{ es.received | currency }} <span>({{ es.receivedCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-out" [class.active]="sfSummaryFilterActive('paid')" (click)="sfApplySummaryFilter('paid')"><small>ERP paid out</small><strong>{{ es.paidOut | currency }} <span>({{ es.paidOutCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-ok" [class.active]="sfSummaryFilterActive('matched')" (click)="sfApplySummaryFilter('matched')"><small>ERP matched</small><strong>{{ es.matchedTotal | currency }} <span>({{ es.matchedCount }})</span></strong></button>
													<button type="button" class="sf-pane-total sf-sum-bad" [class.active]="sfSummaryFilterActive('unmatched')" (click)="sfApplySummaryFilter('unmatched')"><small>ERP unmatched</small><strong>{{ es.openTotal | currency }} <span>({{ es.openCount }})</span></strong></button>
												</div>
												<div class="sf-pane-head">
													<div class="sf-pane-title">ERP ledger <small>({{ sfErpRows().length }})</small></div>
													<input class="form-control form-control-sm sf-pane-search" type="search" aria-label="Search ERP ledger transactions" placeholder="Search ERP…" [(ngModel)]="sfErpSearch" [ngModelOptions]="{standalone: true}" />
												</div>
												<div class="sf-pane-body">
													<div *ngIf="!sfErpRows().length" class="sf-pane-empty">
														<div class="mb-2">No ERP transactions loaded for this account and range.</div>
												<button type="button" class="btn btn-primary btn-sm" (click)="sfLoadErpRows()" [disabled]="sfErpLoading">{{ sfErpLoading ? 'Loading…' : 'Reload ERP ledger' }}</button>
													</div>
													<div *ngFor="let t of sfErpRows()"
														class="sf-row"
														[id]="sfErpMatch(t) ? 'sf-erp-' + sfBtid(t) : null"
														[class.sf-row-matched]="sfErpMatch(t)"
														[class.sf-row-open]="!sfErpMatch(t)"
														[class.sf-row-suggest]="sfIsSuggested(t)"
														[class.sf-hl]="sfErpHl(t)"
														(mouseenter)="sfSetHover(sfErpMatch(t) ? sfBtid(t) : 0)"
														(mouseleave)="sfSetHover(0)"
														(click)="sfErpRowClick(t)">
														<span class="sf-row-date">{{ t.trandate }}</span>
														<span class="sf-row-desc" [matTooltip]="(t.type || '') + ' ' + (t.name || '') + ' ' + (t.reference || '')">
															<span class="sf-row-descmain">
																<small class="sf-row-type">{{ t.typename || t.type }}</small>
																{{ t.name }}
																<small *ngIf="t.debtorno"> · {{ t.debtorno }}</small>
																<small *ngIf="t.reference"> · {{ t.reference }}</small>
															</span>
															<small class="sf-row-meta"><span class="sf-row-acct">{{ sfAcctChip(sfErpAcctCode(t)) }}</span></small>
														</span>
														<span class="sf-row-amt" [class.sf-neg]="t.amount < 0">{{ t.amount | currency }}</span>
														<span class="sf-row-state">
															<span *ngIf="sfErpMatch(t)" class="sf-matched">✓ bank</span>
															<span *ngIf="sfIsInternalReversal(t)" class="sf-reversal-tag">reversal</span>
															<span *ngIf="!sfErpMatch(t) && !sfIsInternalReversal(t)" class="sf-open-dot sf-open-dot-bad" matTooltip="Keyed in the ERP but not seen at the bank"></span>
															<span *ngIf="t.clearedLocked" class="sf-lock-tag" matTooltip="Cleared and locked">🔒</span>
														</span>
														<span class="sf-row-actions" (click)="$event.stopPropagation()">
															<button *ngIf="t.debtorno && t.branchcode && t.type == 12" type="button" class="btn btn-link btn-sm sf-action" (click)="openSfCustomerAccount(t)">Open account</button>
														</span>
													</div>
												</div>
												<div class="sf-pane-foot">
													<span>{{ sfErpRows().length }} shown</span>
													<span class="sf-spacer"></span>
													<span>Shown net <strong [class.sf-neg]="sfRowsTotal(sfErpRows()) < 0">{{ sfRowsTotal(sfErpRows()) | currency }}</strong></span>
												</div>
											</div>
										</div>

										<!-- Inline AP posting drawer: stays inside bank reconciliation. -->
										<div class="sf-post-drawer" *ngIf="sfPostingRow">
											<div class="sf-post-head">
												<span class="sf-post-head-icon sf-post-head-icon--out"><mat-icon>north_east</mat-icon></span>
												<div class="sf-post-head-text">
													<strong>Post bank withdrawal</strong>
													<div class="sf-post-context">
														<span class="sf-post-context-date">{{ sfPostingRow.posted }}</span>
														<span class="sf-post-context-desc" [matTooltip]="sfPostingRow.description">{{ sfPostingRow.description }}</span>
													</div>
												</div>
												<span class="sf-post-amount sf-post-amount--out">{{ sfPostingRow.amount | currency }}</span>
												<button type="button" class="sf-post-close" aria-label="Close" (click)="sfClosePosting()"><mat-icon>close</mat-icon></button>
											</div>

											<div class="sf-post-find" *ngIf="sfPostingMode === 'find'">
												<div class="sf-post-step-head">
													<h6>Choose the vendor</h6>
													<span>Pick who was paid, or create the vendor if they aren't set up yet.</span>
												</div>
												<div class="sf-post-search-row">
													<div class="sf-post-search-input">
														<mat-icon>search</mat-icon>
														<input type="search" [(ngModel)]="sfVendorSearch" [ngModelOptions]="{standalone:true}" (keyup.enter)="sfSearchVendors()" placeholder="Vendor name or ID" aria-label="Search vendors">
													</div>
													<button type="button" class="btn btn-primary" (click)="sfSearchVendors()">Search</button>
													<button type="button" class="btn btn-outline-primary" (click)="sfPostingMode = 'new'"><mat-icon>add_business</mat-icon> Create vendor</button>
												</div>
												<div *ngIf="sfVendorLoading" class="sf-post-empty sf-post-searching">
													<span class="sf-search-spinner"></span>
													{{ sfVendorResults.length ? 'Loading vendor…' : 'Searching vendors…' }}
												</div>
												<div *ngIf="!sfVendorLoading && !sfVendorResults.length" class="sf-post-empty">
													<mat-icon>storefront</mat-icon>
													<div>No vendors matched<ng-container *ngIf="sfVendorSearch"> &ldquo;{{ sfVendorSearch }}&rdquo;</ng-container>. Try fewer words, or set them up now.</div>
													<button type="button" class="btn btn-outline-primary btn-sm" (click)="sfPostingMode = 'new'">Create vendor</button>
												</div>
												<div class="sf-result-list" *ngIf="!sfVendorLoading && sfVendorResults.length">
													<div class="sf-result-count">{{ sfVendorResults.length }} vendor{{ sfVendorResults.length === 1 ? '' : 's' }} found</div>
													<button type="button" class="sf-result" *ngFor="let v of sfVendorResults" (click)="sfSelectPostingVendor(v)">
														<span class="sf-result-avatar">{{ (v.suppname || '?').charAt(0) | uppercase }}</span>
														<span class="sf-result-main">
															<strong>{{ v.suppname }}</strong>
															<small><span class="sf-result-id">{{ v.supplierid }}</span><span *ngIf="v.address3" class="sf-result-meta">{{ v.address3 }}<ng-container *ngIf="v.address4">, {{ v.address4 }}</ng-container></span></small>
														</span>
														<mat-icon class="sf-result-go">chevron_right</mat-icon>
													</button>
												</div>
											</div>

											<div *ngIf="sfPostingMode === 'new'">
												<button type="button" class="sf-post-back" (click)="sfPostingMode = 'find'"><mat-icon>arrow_back</mat-icon> Back to vendor search</button>
												<div class="sf-post-panel">
													<app-vendor-create [embedded]="true" [initialName]="sfVendorSearch" (vendorCreated)="sfVendorCreated($event)" (cancelled)="sfPostingMode = 'find'"></app-vendor-create>
												</div>
											</div>

											<div *ngIf="sfPostingVendor && (sfPostingMode === 'invoice' || sfPostingMode === 'payment')">
												<div class="sf-post-tabs">
													<div class="sf-post-seg">
														<button type="button" [class.active]="sfPostingMode === 'invoice'" (click)="sfPostingMode = 'invoice'"><mat-icon>receipt_long</mat-icon> Create invoice</button>
														<button type="button" [class.active]="sfPostingMode === 'payment'" (click)="sfPostingMode = 'payment'"><mat-icon>payments</mat-icon> Post payment / allocate</button>
													</div>
													<div class="sf-post-identity">
														<span class="sf-result-avatar">{{ (sfPostingVendor.suppname || '?').charAt(0) | uppercase }}</span>
														<span class="sf-post-identity-text">
															<strong>{{ sfPostingVendor.suppname }}</strong>
															<small>{{ sfPostingVendor.supplierid }}</small>
														</span>
														<button type="button" class="sf-post-identity-change" (click)="sfPostingMode = 'find'">Change</button>
													</div>
												</div>
												<div *ngIf="sfPostingMode === 'invoice'" class="sf-post-note">
													<mat-icon>info</mat-icon>
													<span>Bank date and reference are filled below. Choose the expense GL account and the first line will fill with {{ (sfPostingRow.amount < 0 ? -sfPostingRow.amount : sfPostingRow.amount) | currency }} and the bank description.</span>
												</div>
												<div class="sf-post-panel">
													<app-vendor-invoice *ngIf="sfPostingMode === 'invoice'" [vendor_data]="sfPostingVendor" [current_supplier]="sfPostingVendor.supplierid" [bankRecContext]="sfPostingRow" (newvendortrans)="sfPostingMode = 'payment'"></app-vendor-invoice>
													<app-vendor-payment-entry *ngIf="sfPostingMode === 'payment'" [vendor]="sfPostingVendor" [bankRecContext]="sfPostingRow" (newvendordata)="sfPostingCompleted()"></app-vendor-payment-entry>
												</div>
											</div>
										</div>

										<ng-container *ngTemplateOutlet="sfReceiptDrawerTpl"></ng-container>
										</ng-container>
								</div>

								<div *ngIf="sf.message" class="sf-msg">{{ sf.message }}</div>

								<!-- Export source. print/xls and print/pdf both render encoded HTML server
								     side, so the export IS this table — kept off-screen rather than
								     *ngIf'd out, because innerHTML has to exist when the button is hit. -->
								<div class="sf-print-source" #sfFeedPrint *ngIf="sfPrintReady">
									<h3>{{ sfBankLabel(selectedBankAccount.value) }} ({{ selectedBankAccount.value }}) — bank feed</h3>
									<p>{{ sfChipLabel() }} · {{ sfFormatYmdDisplay(datefrom.value) }} to {{ sfFormatYmdDisplay(dateto.value) }} · {{ sfBankRows().length }} rows</p>
									<table border="1" cellspacing="0" cellpadding="4">
										<thead>
											<tr>
												<th>Posted</th><th>Description</th><th>Amount</th>
												<th>Bank status</th><th>Match state</th><th>ERP transno</th><th>Reason</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let s of sfBankRows()">
												<td>{{ s.posted }}</td>
												<td>{{ s.description }}</td>
												<td align="right">{{ s.amount | number:'1.2-2' }}</td>
												<td>{{ s.pending ? 'Pending' : 'Posted' }}</td>
												<td>{{ sfRowStateLabel(s) }}</td>
												<td>{{ s.matchTransno || (s.feedPostTransno || '') }}</td>
												<td>{{ s.matchReason }}</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<th colspan="2">Total ({{ sfBankRows().length }} rows)</th>
												<th align="right">{{ sfExportTotal() | number:'1.2-2' }}</th>
												<th colspan="4"></th>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</div>

							<!-- Connections tab: everything about GETTING data into the feed — SimpleFIN
							     connect/account-mapping and statement-file drop. Bank Feed (above) is
							     matching only; this tab is setup only, always available regardless of
							     sf.connected so a file-only tenant (no bridge) can still drop statements. -->
							<div class="bank-rec-tabpane bank-rec-connections" [hidden]="activeTab !== 'connections'">
								<div class="sf-card">
									<div class="sf-head">
										<h5 class="mb-0">Connections</h5>
										<span class="sf-status" [class.on]="sf.connected">{{ sf.connected ? 'SimpleFIN connected' : 'SimpleFIN not connected' }}</span>
									</div>

									<div class="sf-last-import" aria-live="polite" *ngIf="sf.connected">
										<ng-container *ngIf="sf.lastImport; else sfNeverImported">
											<mat-icon class="sf-last-import-icon">history</mat-icon>
											Last import {{ sfLastImportDate() | date:'M/d/yy, h:mm a' }}
											— <strong>{{ sf.lastImport.new }}</strong> new, {{ sf.lastImport.updated }} updated
											<span class="sf-last-import-range">({{ sf.lastImport.start }} → {{ sf.lastImport.end }})</span>
											</ng-container>
										<ng-template #sfNeverImported>
											<mat-icon class="sf-last-import-icon">history</mat-icon>
											No import from the bank recorded yet — click “Import from bank” on the Bank Feed tab.
										</ng-template>
									</div>
									<p class="text-muted small mb-2" *ngIf="sf.connected">“Import from bank” (on the Bank Feed tab) always pulls the last 12 months (as far back as your bank allows) and keeps everything with its matches — pending same-day activity included. The date range and View buttons there only control what is shown and matched.</p>

									<div *ngIf="!sf.connected" class="sf-connect">
										<p class="text-muted small mb-2">Paste a SimpleFIN setup token (from your SimpleFIN Bridge) to connect a read-only bank feed.</p>
										<div class="sf-connect-row">
											<textarea class="form-control form-control-sm sf-token" rows="2" placeholder="Setup token (base64)…" [(ngModel)]="sf.token"></textarea>
											<button class="btn btn-primary btn-sm" (click)="simplefinConnect()" [disabled]="sf.claiming">{{ sf.claiming ? 'Connecting…' : 'Connect' }}</button>
										</div>
									</div>

									<div class="sf-setup" *ngIf="sf.connected">
									<h6 class="sf-subhead">Account setup <span *ngIf="sfSavingMap" class="text-muted">· saving…</span></h6>
									<div *ngIf="sf.loadingAccounts" class="text-muted small">Loading accounts…</div>
									<table *ngIf="sf.accounts.length" class="table table-sm sf-accounts">
										<thead><tr><th>Bank</th><th>Account</th><th class="text-right">Balance</th><th>Status</th><th>Maps to ERP bank account</th></tr></thead>
										<tbody>
											<tr *ngFor="let a of sf.accounts" [class.sf-acct-stale]="a.needsReconnect">
												<td>{{ a.org }}</td>
												<td>{{ a.name }}</td>
												<td class="text-right">{{ a.balance }} {{ a.currency }}</td>
												<td class="sf-acct-status">
													<a *ngIf="a.needsReconnect; else sfConnOk" class="sf-reconnect" [href]="sf.manageUrl || 'https://beta-bridge.simplefin.org/'" target="_blank" rel="noopener" matTooltip="This connection needs re-authentication — it has stopped importing. Reconnect at SimpleFIN, then Import from bank.">
														<mat-icon>link_off</mat-icon> Reconnect
													</a>
													<ng-template #sfConnOk><span class="sf-conn-ok"><span class="sf-dot"></span> Connected</span></ng-template>
												</td>
												<td>
													<select class="form-control form-control-sm" [(ngModel)]="sf.accountMap[a.id]" (ngModelChange)="simplefinMapChanged()">
														<option value="">— not mapped —</option>
														<option *ngFor="let b of sf.bankAccounts" [value]="b.accountcode">{{ b.bankaccountname }} ({{ b.accountcode }})</option>
													</select>
												</td>
											</tr>
										</tbody>
									</table>
									<div class="sf-setup-actions">
										<button class="btn btn-outline-secondary btn-sm" (click)="loadSimplefinAccounts()" [disabled]="sf.loadingAccounts">Refresh bank accounts</button>
										<button class="btn btn-outline-danger btn-sm" (click)="simplefinDisconnect()">Disconnect</button>
									</div>
									</div>

									<div *ngIf="sf.message" class="sf-msg">{{ sf.message }}</div>
								</div>
							</div>

							<!-- Statement Files tab: import a downloaded statement into the same feed, so a
							     dead/never-set-up bridge can never block a reconciliation. Its own tab (not
							     folded into Connections) because dropping a file is a routine, repeated task —
							     not one-time setup like connecting SimpleFIN. Independent of sf.connected. -->
							<div class="bank-rec-tabpane bank-rec-files" [hidden]="activeTab !== 'files'">
								<div class="sf-card">
									<div class="sf-head">
										<h5 class="mb-0">Statement Files</h5>
									</div>
									<app-statement-import
										[bankaccounts]="sf.bankAccounts"
										[defaultBank]="selectedBankAccount.value || ''"
										(imported)="onStatementImported($event)">
									</app-statement-import>
								</div>
							</div>

							<!-- Batch match: where the ERP books every receipt individually and the bank
							     shows one lumped deposit, no 1:1 match exists. The server proposes which SET
							     of ERP rows makes up each bank line; this tab is where those are reviewed and
							     accepted. Rules are per bank account because the batching is (card processor
							     settles four brands as one line, a branch deposit combines two days of cash). -->
							<div class="bank-rec-tabpane bank-rec-groups" [hidden]="activeTab !== 'groups'">
								<div class="sf-card">
									<div class="sf-head">
										<h5 class="mb-0">Batch match</h5>
										<span class="sf-spacer"></span>
										<span class="text-muted small" *ngIf="grp.counts?.lines">{{ grp.counts.withGroups }} of {{ grp.counts.lines }} bank lines have a candidate group</span>
									</div>

									<div class="grp-toolbar">
										<mat-form-field appearance="outline" class="grp-acct">
											<mat-label>Bank Account</mat-label>
											<mat-select [(ngModel)]="grp.bankaccount" [ngModelOptions]="{standalone:true}" (selectionChange)="grpAccountChanged()">
												<mat-option *ngFor="let acc of (sf.bankAccounts?.length ? sf.bankAccounts : bankAccounts)" [value]="acc.accountcode">
													{{ acc.bankaccountname }} ({{ acc.accountcode }})
												</mat-option>
											</mat-select>
										</mat-form-field>
										<mat-form-field appearance="outline" class="sf-daterange">
											<mat-label>Date range</mat-label>
											<mat-date-range-input [rangePicker]="grpRangePicker">
												<input matStartDate [formControl]="datefrom" placeholder="From">
												<input matEndDate [formControl]="dateto" placeholder="To">
											</mat-date-range-input>
											<mat-datepicker-toggle matSuffix [for]="grpRangePicker"></mat-datepicker-toggle>
											<mat-date-range-picker #grpRangePicker></mat-date-range-picker>
										</mat-form-field>
										<span class="sf-spacer"></span>
										<button type="button" class="btn btn-primary btn-sm" (click)="grpPropose()" [disabled]="grp.loading || !grp.bankaccount">{{ grp.loading ? 'Proposing…' : 'Propose groups' }}</button>
									</div>

									<p class="grp-message text-muted small" *ngIf="grp.message">{{ grp.message }}</p>

									<!-- Rules. Deliberately in front of the reviewer rather than on a settings
									     screen: a wrong lag or a missing tender group is the usual reason a line
									     has no candidate, and this is where they notice. -->
									<div class="grp-rules" *ngIf="grp.settings">
										<div class="grp-rules-head">
											<strong>Grouping rules for {{ grp.bankaccount }}</strong>
											<span class="sf-spacer"></span>
											<button type="button" class="btn btn-outline-secondary btn-sm" (click)="grpSaveSettings()" [disabled]="grp.savingSettings">{{ grp.savingSettings ? 'Saving…' : 'Save rules' }}</button>
										</div>

										<div class="grp-rules-row">
											<mat-form-field appearance="outline">
												<mat-label>Also search these accounts</mat-label>
												<mat-select [(ngModel)]="grp.settings.offset_accounts" [ngModelOptions]="{standalone:true}" multiple>
													<ng-container *ngFor="let acc of (sf.bankAccounts?.length ? sf.bankAccounts : bankAccounts)">
														<mat-option *ngIf="acc.accountcode !== grp.bankaccount" [value]="acc.accountcode">{{ acc.bankaccountname }} ({{ acc.accountcode }})</mat-option>
														</ng-container>
												</mat-select>
												<mat-hint>When the ERP books the receipt on a different account than the bank deposits it</mat-hint>
											</mat-form-field>
											<mat-form-field appearance="outline" class="grp-num">
												<mat-label>Days ERP may precede bank</mat-label>
												<input matInput type="number" min="0" max="60" [(ngModel)]="grp.settings.lag_days_back" [ngModelOptions]="{standalone:true}">
											</mat-form-field>
											<mat-form-field appearance="outline" class="grp-num">
												<mat-label>Days ERP may follow bank</mat-label>
												<input matInput type="number" min="0" max="60" [(ngModel)]="grp.settings.lag_days_fwd" [ngModelOptions]="{standalone:true}">
											</mat-form-field>
											<mat-form-field appearance="outline" class="grp-num">
												<mat-label>Tolerance $</mat-label>
												<input matInput type="number" min="0" step="0.01" [(ngModel)]="grp.settings.variance_abs" [ngModelOptions]="{standalone:true}">
												<mat-hint>0 keeps every variance visible</mat-hint>
											</mat-form-field>
											<mat-form-field appearance="outline" class="grp-num">
												<mat-label>Tolerance %</mat-label>
												<input matInput type="number" min="0" step="0.001" [(ngModel)]="grp.settings.variance_pct" [ngModelOptions]="{standalone:true}">
											</mat-form-field>
										</div>

										<!-- Tender groups: the tender types the BANK settles as a single line. -->
										<div class="grp-tenders">
											<div class="grp-tenders-title">Tenders the bank settles together</div>
											<p class="text-muted small mb-2">A card processor pays one merchant settlement for all card brands, so those tender types have to be totalled together or the day can never tie. Types not listed here are grouped on their own.</p>
											<div class="grp-tender-list" *ngIf="grp.settings.tender_groups?.length">
												<div class="grp-tender-chip" *ngFor="let tg of grp.settings.tender_groups; let ti = index">
													<strong>{{ tg.label }}</strong>
													<span>{{ tg.types.join(' + ') }}</span>
													<button type="button" class="btn btn-link btn-sm" (click)="grpRemoveTenderGroup(ti)" [attr.aria-label]="'Remove tender group ' + tg.label">Remove</button>
												</div>
											</div>
											<div class="grp-tender-add">
												<mat-form-field appearance="outline">
													<mat-label>Group name</mat-label>
													<input matInput [(ngModel)]="grp.newTenderLabel" [ngModelOptions]="{standalone:true}" placeholder="Cards (EPX)">
												</mat-form-field>
												<mat-form-field appearance="outline">
													<mat-label>Tender types</mat-label>
													<mat-select [(ngModel)]="grp.newTenderTypes" [ngModelOptions]="{standalone:true}" multiple>
														<ng-container *ngFor="let t of grp.tenderTypes">
															<mat-option *ngIf="!grpTenderTypeTaken(t.type)" [value]="t.type">{{ t.type }} <small class="text-muted">({{ t.count }})</small></mat-option>
															</ng-container>
													</mat-select>
													<mat-hint>Pick two or more</mat-hint>
												</mat-form-field>
												<button type="button" class="btn btn-outline-primary btn-sm" (click)="grpAddTenderGroup()" [disabled]="!grp.newTenderLabel || (grp.newTenderTypes?.length || 0) < 2">Add group</button>
											</div>
										</div>

										<!-- Per-tender over/short allowance: cash drawers never tie to the penny. -->
										<div class="grp-tenders">
											<div class="grp-tenders-title">Per-tender over/short allowance</div>
											<p class="text-muted small mb-2">A cash drawer counts a few dollars over or short of what the POS keyed, so cash can never tie to the penny. A tolerance here admits the match as a near tie — the difference is shown on the candidate and recorded on the match, never absorbed. Leave tenders that must tie exactly (checks, cards) off this list.</p>
											<div class="grp-tender-list" *ngIf="grpTypeVarEntries().length">
												<div class="grp-tender-chip" *ngFor="let v of grpTypeVarEntries()">
													<strong>{{ v.type }}</strong>
													<span>± {{ v.amount | currency }}</span>
													<button type="button" class="btn btn-link btn-sm" (click)="grpRemoveTypeVariance(v.type)" [attr.aria-label]="'Remove allowance for ' + v.type">Remove</button>
												</div>
											</div>
											<div class="grp-tender-add">
												<mat-form-field appearance="outline">
													<mat-label>Tender type</mat-label>
													<mat-select [(ngModel)]="grp.newVarType" [ngModelOptions]="{standalone:true}">
														<mat-option *ngFor="let t of grp.tenderTypes" [value]="t.type">{{ t.type }} <small class="text-muted">({{ t.count }})</small></mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field appearance="outline" class="grp-num">
													<mat-label>Allowance $</mat-label>
													<input matInput type="number" min="0.01" step="0.01" [(ngModel)]="grp.newVarAmount" [ngModelOptions]="{standalone:true}">
												</mat-form-field>
												<button type="button" class="btn btn-outline-primary btn-sm" (click)="grpAddTypeVariance()" [disabled]="!grp.newVarType || !(grp.newVarAmount > 0)">Add allowance</button>
											</div>
										</div>
									</div>

									<div class="text-center my-4" *ngIf="grp.loading">
										<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
									</div>

									<div class="grp-results" *ngIf="!grp.loading && grp.proposals.length">
										<div class="sf-chips">
											<button type="button" class="sf-chip" [class.on]="grp.onlyTies" [attr.aria-pressed]="grp.onlyTies" (click)="grp.onlyTies = true">With candidates ({{ grp.counts.withGroups }})</button>
											<button type="button" class="sf-chip" [class.on]="!grp.onlyTies" [attr.aria-pressed]="!grp.onlyTies" (click)="grp.onlyTies = false">All unmatched ({{ grp.counts.lines }})</button>
											<span class="sf-spacer"></span>
											<span class="text-muted small" *ngIf="grp.poolWindow?.length === 2">ERP pool {{ grp.poolWindow[0] }} → {{ grp.poolWindow[1] }} · {{ grp.poolSize }} rows</span>
										</div>

										<!-- Post everything that ties to the penny in one pass; the near-ties
										     are left behind deliberately, they are the ones needing a decision. -->
										<div class="grp-bulk" *ngIf="grpExactCount()">
											<button type="button" class="btn btn-primary btn-sm" (click)="grpMatchAllExact()" [disabled]="grpBulk.running">
												<mat-progress-spinner *ngIf="grpBulk.running" diameter="14" mode="indeterminate" color="accent"></mat-progress-spinner>
												{{ grpBulk.running
													? ('Matching ' + (grpBulk.done + 1) + ' of ' + grpBulk.total + '…')
													: ('Match all ' + grpExactCount() + ' exact ties · ' + (grpExactValue() | currency)) }}
											</button>
											<span class="text-muted small">Near-ties are left for you to review one by one.</span>
										</div>

										<div class="grp-line" *ngFor="let p of grpVisibleProposals(); let pi = index">
											<div class="grp-day" *ngIf="grpIsNewDay(grpVisibleProposals(), pi)">
												{{ p.posted }}
												<small>{{ grpDayLines(grpVisibleProposals(), p.posted) }} bank line{{ grpDayLines(grpVisibleProposals(), p.posted) === 1 ? '' : 's' }}</small>
											</div>
											<div class="grp-line-head">
												<span class="grp-line-date">{{ p.posted }}</span>
												<span class="grp-line-desc">{{ p.description || 'No bank description' }}</span>
												<strong class="grp-line-amt" [class.sf-neg]="p.amount < 0">{{ p.amount | currency }}</strong>
												<span class="grp-line-recon" *ngIf="grpBest(p) as b">
													<span class="grp-recon-cell"><small>recorded</small><strong>{{ b.sum | currency }}</strong></span>
													<span class="grp-recon-cell grp-recon-diff"
													      [class.grp-recon-tie]="!b.variance"
													      [class.grp-recon-off]="b.variance"><small>diff</small>
														<strong>{{ b.variance ? ((b.variance > 0 ? '+' : '') + (b.variance | currency)) : 'ties' }}</strong></span>
												</span>
											</div>

											<div class="grp-none" *ngIf="!p.groups?.length">
												No set of ERP rows in the window adds up to this. Either it isn't on the books yet, or the lag/tender rules above need widening.
											</div>

											<div class="grp-cand" *ngFor="let g of p.groups; let gi = index" [class.grp-cand-exact]="g.tier === 1">
												<div class="grp-cand-main">
													<span class="grp-tier" [class.grp-tier-1]="g.tier === 1" [class.grp-tier-2]="g.tier === 2" [class.grp-tier-3]="g.tier === 3">{{ grpTierLabel(g.tier) }}</span>
													<span class="grp-cand-shape">
														<strong>{{ grpShapeLabel(g) }}</strong>
														<small>{{ g.count }} ERP row{{ g.count === 1 ? '' : 's' }} · {{ g.dateFrom }}<span *ngIf="g.dateTo !== g.dateFrom"> → {{ g.dateTo }}</span><span *ngIf="g.droppedCount"> · {{ g.droppedCount }} straggler{{ g.droppedCount === 1 ? '' : 's' }} left out</span><span *ngIf="g.pulledCount"> · {{ g.pulledCount }} late row{{ g.pulledCount === 1 ? '' : 's' }} pulled in from another day</span></small>
														<small *ngIf="grpTypeSummary(g)" class="grp-cand-types">{{ grpTypeSummary(g) }}</small>
														<small *ngIf="g.crossAccount" class="grp-cand-cross">Rows sit on {{ g.bankact }}, not {{ grp.bankaccount }}</small>
														<small *ngIf="g.alreadyCleared" class="grp-cand-cleared">{{ g.alreadyCleared }} already marked cleared on the rec</small>
																<!-- Accepting a co-deposit also matches these slips, so name them. -->
																<small *ngIf="g.siblings?.length" class="grp-cand-codep">Also matches:
																	<span *ngFor="let s of g.siblings">{{ s.posted }} {{ s.description }} {{ s.amount | currency }}</span>
																	<em>total {{ g.coDepositTotal | currency }}</em></small>
													</span>
													<span class="grp-cand-sums">
														<strong>{{ g.sum | currency }}</strong>
														<small [class.grp-var-zero]="!g.variance">{{ g.variance ? ('off by ' + (g.variance | currency)) : 'ties exactly' }}</small>
													</span>
													<button type="button" class="btn btn-link btn-sm" (click)="grpToggleRows(p, gi)">{{ grp.expanded[grpKey(p, gi)] ? 'Hide rows' : 'Show rows' }}</button>
													<button type="button" class="btn btn-sm" [class.btn-primary]="g.tier === 1" [class.btn-outline-primary]="g.tier !== 1" (click)="grpAcceptGroup(p, g, gi)" [disabled]="grp.matching[grpKey(p, gi)]">{{ grp.matching[grpKey(p, gi)] ? 'Matching…' : 'Match' }}</button>
												</div>
												<table class="grp-rows" *ngIf="grp.expanded[grpKey(p, gi)]">
													<thead>
														<tr>
															<th>Date</th><th>Tender</th><th>Paid by</th><th>Cheque / ref</th>
															<th>Order</th><th class="grp-rows-amt">Amount</th><th></th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let r of g.rows">
															<td>{{ r.transdate }}</td>
															<td>{{ r.banktranstype || '—' }}</td>
															<td class="grp-rows-party">
																<strong>{{ r.counterparty || 'Unnamed' }}</strong>
																<small *ngIf="r.partyno">{{ r.partyno }}<span *ngIf="r.branchcode">.{{ r.branchcode }}</span></small>
															</td>
															<td>{{ r.ref || '—' }}</td>
															<!-- order_ = 1 is the ERP's "no specific order" sentinel, not order #1. -->
															<td class="grp-rows-no">{{ r.order_ && r.order_ !== 1 ? r.order_ : '—' }}</td>
															<td class="grp-rows-amt">{{ r.amount | currency }}</td>
															<td class="grp-rows-flag">{{ r.cleared ? 'cleared' : '' }}</td>
														</tr>
													</tbody>
													<tfoot>
														<tr class="grp-rows-total">
															<td colspan="5">{{ g.count }} row{{ g.count === 1 ? '' : 's' }}</td>
															<td class="grp-rows-amt">{{ g.sum | currency }}</td>
															<td></td>
														</tr>
													</tfoot>
												</table>
											</div>
										</div>
									</div>


										<div class="grp-empty text-center text-muted my-4" *ngIf="!grp.loading && !grp.proposals.length && grp.loaded">
										Pick a bank account and press <strong>Propose groups</strong>.
									</div>
								</div>
							</div>

							<!-- AR receipts tab: match bank deposits to keyed receipts, or post new ones -->
							<div class="bank-rec-tabpane bank-rec-ar" [hidden]="activeTab !== 'ar'">
								<div class="sf-card">
									<div *ngIf="sf.loaded && !sf.connected" class="sf-connect">
										<p class="text-muted small mb-2">The bank feed is not connected — connect it on the Bank Feed tab first.</p>
									</div>
									<!-- One toolbar: window, range, unapplied total, refresh. Splitting these over
									     two rows left the second one with no slack, so every item wrapped. -->
									<div class="sf-ar-range">
										<span class="sf-import-window" role="group" aria-label="Proposal window">
											<span class="sf-import-window-label">Deposits from</span>
											<button *ngFor="let d of sfImportWindows" type="button" class="sf-chip sf-chip-window" [class.on]="sfImportWindowActive(d)" (click)="sfArSetWindow(d)" [matTooltip]="'Propose over the last ' + d + ' days'">{{ d === 365 ? '1y' : d + 'd' }}</button>
										</span>
										<span class="text-muted small">{{ datefrom.value | date:'M/d/yy' }} → {{ dateto.value | date:'M/d/yy' }}</span>
										<span *ngIf="!sfArWindowIsPreset()" class="text-muted small sf-ar-range-custom" matTooltip="This range came from the Reconciliation tab, not one of the buttons. Picking a window here changes it there too.">(custom)</span>
										<!-- Total and Refresh travel together, so a narrow pane wraps them as one
										     right-aligned group instead of stranding the button on its own row. -->
										<span class="sf-ar-range-end">
											<span *ngIf="sfAr.loaded" class="sf-ar-grand" matTooltip="Total deposit value still waiting to be applied to AR">{{ sfArUnappliedTotal() | currency }} unapplied</span>
											<button class="btn btn-outline-secondary btn-sm" (click)="sfArPropose()" [disabled]="sfAr.loading || sfAr.posting">{{ sfAr.loading ? 'Analyzing…' : 'Refresh proposals' }}</button>
										</span>
									</div>
									<!-- Check log: payments known BEFORE they reach the bank. Everything else on
									     this screen starts from a bank row; this starts from the paper, which is the
									     only thing that can name the customer on a nameless mobile-check deposit. -->
									<div class="sf-ar-tier sf-log">
										<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfLog.open" (click)="sfLogToggle()">
											<span class="sf-ar-dot sf-ar-dot-log" aria-hidden="true"></span>
											Check log — expected payments
											<span class="sf-ar-count">{{ sfLogOpenCount() }}<span *ngIf="sfLog.rows.length"> · {{ sfLogTotal() | currency }}</span></span>
											<span class="sf-ar-caret" aria-hidden="true">{{ sfLog.open ? '▾' : '▸' }}</span>
										</button>
										<ng-container *ngIf="sfLog.open">
											<div *ngIf="sfLog.message" class="text-danger small">{{ sfLog.message }}</div>
											<div *ngIf="sfLog.loading" class="text-muted small">Loading the log…</div>
											<div class="sf-log-bar">
												<span class="text-muted small">Checks in hand, or already keyed and waiting for the deposit to land.</span>
												<span class="sf-spacer"></span>
												<button *ngIf="sfLogPostable().length" class="btn btn-success btn-sm"
														(click)="sfLogPostAll()" [disabled]="sfLog.posting || !!sfLog.draft"
														matTooltip="Post a receipt for each logged check/cash line — allocation, GL and the bank row are built by the same path a deposit uses. The deposit will match these receipts when it lands.">
													{{ sfLog.posting
														? ('Posting ' + sfLog.postDone + '/' + sfLog.postTotal + '…')
														: ('Post ' + sfLogPostable().length + ' logged payment' + (sfLogPostable().length === 1 ? '' : 's') + ' · ' + (sfLogPostableTotal() | currency)) }}
												</button>
												<button class="btn btn-outline-secondary btn-sm" (click)="sfLogNew()" [disabled]="!!sfLog.draft">Add line</button>
											</div>

											<!-- Photo of the log page. The order number written next to each customer is
											     what identifies the payment — it resolves to exactly one invoice — so a
											     misread amount shows up as a discrepancy instead of a silent short-pay. -->
											<div class="sf-shot" *ngIf="!sfShot.rows.length">
												<div class="sf-shot-drop" [class.over]="sfShot.over" [class.busy]="sfShot.reading"
													 (dragover)="sfLogDragOver($event)" (dragleave)="sfLogDragLeave()" (drop)="sfLogDrop($event)">
													<ng-container *ngIf="!sfShot.reading">
														<mat-icon class="sf-shot-icon">photo_camera</mat-icon>
														<div><strong>Drop a photo of the check log</strong></div>
										<div class="text-muted small">or paste it with <kbd>⌘V</kbd> / <kbd>Ctrl-V</kbd></div>
														<div class="text-muted small">or <label class="sf-shot-browse">browse<input type="file" accept="image/*,application/pdf" hidden (change)="sfLogPickShot($event)"></label> — JPEG, PNG, WEBP or PDF</div>
														</ng-container>
													<ng-container *ngIf="sfShot.reading">
														<div class="sf-shot-spin" aria-hidden="true"></div>
														<div class="text-muted small">Reading {{ sfShot.fileName }} and matching order numbers…</div>
														</ng-container>
												</div>
											</div>

											<!-- Review grid: nothing is saved until these are ticked. -->
											<div class="sf-shot-review" *ngIf="sfShot.rows.length">
												<div class="sf-shot-head">
													<strong>{{ sfShot.fileName }}</strong>
													<span class="sf-ar-count">{{ sfShot.counts?.rows }} line{{ sfShot.counts?.rows === 1 ? '' : 's' }} · {{ sfShotTotal() | currency }}</span>
													<span *ngIf="sfShot.counts?.flagged" class="sf-shot-flagcount">{{ sfShot.counts?.flagged }} need{{ sfShot.counts?.flagged === 1 ? 's' : '' }} a look</span>
													<span *ngIf="sfShot.depositDate" class="text-muted small">banked {{ sfShot.depositDate }}</span>
													<span class="sf-spacer"></span>
													<button class="btn btn-link btn-sm" (click)="sfShotDiscard()" [disabled]="sfShot.saving">Discard</button>
													<button class="btn btn-success btn-sm" (click)="sfShotSave()" [disabled]="sfShot.saving || !sfShotSelCount()">
														{{ sfShot.saving ? 'Saving…' : ('Add ' + sfShotSelCount() + ' line' + (sfShotSelCount() === 1 ? '' : 's') + ' · ' + (sfShotSelTotal() | currency)) }}
													</button>
												</div>
												<table class="table table-sm sf-txns">
													<thead><tr><th></th><th>Read as</th><th>Resolved customer</th><th>Invoices</th><th class="text-right">Amount</th><th>Check</th></tr></thead>
													<tbody>
														<tr *ngFor="let r of sfShot.rows" [class.sf-shot-flagged]="r.issues?.length || r.pick_issue">
															<td><input type="checkbox" [(ngModel)]="r._sel" [disabled]="!sfShotCanPick(r)" [attr.aria-label]="'Include ' + r.read_payer"></td>
															<td class="sf-desc">
																<span class="sf-shot-hand">{{ r.read_payer }}</span>
																<div class="text-muted small">{{ r.order_refs?.join(', ') }}<span *ngIf="r.log_date"> · {{ r.log_date }}</span></div>
															</td>
															<!-- Placed by order number: settled, shown as text. Placed by name only: a
															     shortlist to choose from, because two real accounts can carry the same
															     name and only a human can say which one wrote the check. -->
															<td class="sf-desc">
																<ng-container *ngIf="r.candidates?.length; else shotFixedCust">
																	<select class="form-control form-control-sm sf-shot-pick" [ngModel]="r.debtorno"
																			(ngModelChange)="sfShotPick(r, $event)" [attr.aria-label]="'Customer for ' + r.read_payer">
																		<option value="">— pick a customer —</option>
																		<option *ngFor="let c of r.candidates" [value]="c.debtorno">{{ sfShotCandLabel(c) }}</option>
																	</select>
																</ng-container>
																<ng-template #shotFixedCust>
																	<strong *ngIf="r.debtorno">{{ r.cust_name }}</strong>
																	<span *ngIf="!r.debtorno" class="text-danger">not identified</span>
																	<span *ngIf="r.debtorno" class="text-muted small"> {{ r.debtorno }}</span>
																</ng-template>
															</td>
															<td class="small">
																<span *ngFor="let d of r.docs" class="sf-log-doc" [class.sf-log-doc-paid]="d.settled" [matTooltip]="'balance ' + (d.outstanding | currency)">{{ d.transno }}</span>
																<span *ngIf="!r.docs?.length" class="text-muted">—</span>
															</td>
															<td class="text-right">
																<input type="number" step="0.01" min="0" class="form-control form-control-sm sf-shot-amt"
																	   [(ngModel)]="r.amount" (ngModelChange)="sfShotAmountChange(r)"
																	   [class.sf-shot-amt-bad]="!(r.amount > 0)"
																	   [attr.aria-label]="'Amount for ' + r.read_payer">
																<div *ngIf="r._readAmount !== r.amount" class="sf-shot-delta">read as {{ r._readAmount | currency }}</div>
																<div *ngIf="sfShotDocTotal(r) && sfShotDocTotal(r) !== r.amount" class="sf-shot-delta">invoice {{ sfShotDocTotal(r) | currency }}</div>
															</td>
															<td class="small">
																<span *ngIf="!r.issues?.length && !r.pick_issue && !sfShotAmountIssue(r)" class="sf-shot-ok">✓</span>
																<div *ngIf="sfShotAmountIssue(r)" class="sf-shot-issue">{{ sfShotAmountIssue(r) }}</div>
																<div *ngIf="r.pick_issue" class="sf-shot-issue sf-shot-pickissue">{{ r.pick_issue }}</div>
																<div *ngFor="let i of r.issues" class="sf-shot-issue">{{ i }}</div>
															</td>
														</tr>
													</tbody>
												</table>
												<div class="sf-shot-note text-muted small">Amounts are transcribed exactly as written — where the paper disagrees with the invoice, the invoice figure is shown beneath it. A row placed by name rather than by order number is never pre-ticked: ticking it is your confirmation, and it will allocate oldest-first. Key an amount the reader could not make out straight into the row — whatever it first read stays visible underneath.</div>
											</div>

											<!-- Draft editor: only shown here for NEW lines (no id). Edits of existing
											     rows render inline as an expansion row inside each table below. -->
											<div *ngIf="sfLog.draft && !sfLog.draft.id" class="sf-log-draft">
												<div class="sf-log-draft-head">
													<strong>Add money in hand</strong>
													<span class="text-muted small">Confirm the customer, amount and invoices before posting.</span>
													<button type="button" class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
												</div>
												<div class="sf-log-fields">
													<label>Customer acct<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.debtorno" placeholder="C00421"></label>
													<label>Name<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.cust_name" placeholder="as written on the log"></label>
													<label>Branch<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.branchcode" placeholder="01"></label>
													<label>Amount<input type="number" step="0.01" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.amount"></label>
													<label matTooltip="Which ERP payment method the receipt posts under">Tender<select class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.instrument">
														<option value="check">Check</option>
														<option value="cash">Cash</option>
													</select></label>
													<label matTooltip="Invoice transno(s), comma separated. Naming them here is what stops oldest-first allocation from clearing a different invoice.">Invoices<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.transnosText" placeholder="130306647"></label>
													<label matTooltip="Open credit notes to consume alongside the check">Credits<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.creditTransnosText" placeholder="optional"></label>
													<label>Check #<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.check_no"></label>
													<label matTooltip="The date written on the paper line — usually the invoice date, not the deposit date">Log date<input type="date" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.log_date"></label>
													<label>Deposit batch<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.deposit_batch" placeholder="2026-07-30"></label>
													<label class="sf-log-wide">Notes<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.notes"></label>
												</div>
												<div class="sf-log-draft-actions">
													<button class="btn btn-success btn-sm" (click)="sfLogSave()" [disabled]="sfLog.saving">{{ sfLog.saving ? 'Saving…' : 'Save line' }}</button>
													<button class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
												</div>
											</div>

											<div *ngIf="sfLog.loaded && !sfLog.rows.length" class="text-muted small sf-ar-empty">Nothing logged. Add the lines off the deposit slip and they will resolve their deposits automatically.</div>
											<!-- Three states, three sections. One flat list meant decoding a status blob per
											     row to learn whether anything was owed of you; each section now says what it
											     wants in its own heading, so the rows carry no state text at all. -->
											<div *ngIf="sfLogByState('expected').length" class="sf-log-group">
												<div class="sf-log-group-head">
													<span class="sf-log-dot sf-log-dot-todo" aria-hidden="true"></span>
													<strong>Money in hand — not posted yet</strong>
													<span class="sf-ar-count">{{ sfLogByState('expected').length }} · {{ sfLogStateTotal('expected') | currency }}</span>
												</div>
												<table class="table table-sm sf-txns">
													<thead><tr><th>Logged</th><th>Customer</th><th>Invoices</th><th class="text-right">Amount</th><th></th></tr></thead>
													<tbody>
														<ng-container *ngFor="let l of sfLogByState('expected')">
															<tr [class.sf-log-stale]="l.stale" [class.sf-log-editing]="sfLogIsEditing(l)">
																<td class="small">{{ l.log_date_disp || '—' }}<div *ngIf="l.deposit_batch" class="text-muted">slip {{ l.deposit_batch }}</div></td>
																<td class="sf-desc"><strong>{{ l.cust_name || l.debtorno }}</strong>
																	<span class="sf-log-tender">{{ l.instrument === 'cash' ? 'cash' : 'check' }}<span *ngIf="l.check_no"> #{{ l.check_no }}</span></span>
																	<div *ngIf="l.notes" class="text-muted small">{{ l.notes }}</div>
																	<div *ngIf="l.stale" class="text-danger small">that invoice was already settled another way — check before posting</div></td>
																<td class="small">
																	<span *ngIf="!l.docs.length" class="text-muted">oldest-first</span>
																	<span *ngFor="let d of l.docs" class="sf-log-doc" [class.sf-log-doc-paid]="d.settled">{{ d.transno }}<span *ngIf="d.settled" matTooltip="This invoice is already settled">✓</span></span>
																</td>
																<td class="text-right">{{ l.amount | currency }}</td>
																<td class="text-nowrap">
																	<button class="btn btn-outline-secondary btn-sm" (click)="sfLogPreview(l)" [disabled]="l._planLoading || (!!sfLog.draft && !sfLogIsEditing(l))">
																		{{ l._plan ? 'Hide review' : (l._planLoading ? 'Checking…' : 'Review allocation') }}
																	</button>
																	<button class="btn btn-success btn-sm" (click)="sfLogPost(l)"
																		[disabled]="l._posting || sfLog.posting || !!sfLog.draft"
																		matTooltip="Post the receipt now — the money is in hand. When the deposit lands it will MATCH this receipt instead of posting a second one.">
																		{{ l._posting ? 'Posting…' : 'Post receipt' }}
																	</button>
																	<button class="btn btn-link btn-sm" (click)="sfLogEdit(l)" [disabled]="sfLogIsEditing(l) || (!!sfLog.draft && !sfLogIsEditing(l))">Edit</button>
																	<button class="btn btn-link btn-sm text-danger" (click)="sfLogDelete(l)" [disabled]="!!sfLog.draft">Remove</button>
																	<div *ngIf="l._postStatus" class="text-muted small">{{ l._postStatus }}</div>
																</td>
															</tr>
															<!-- Inline allocation review -->
															<tr *ngIf="l._plan" class="sf-ar-planrow">
																<td colspan="5">
																	<div class="sf-ar-plan-wrap">
																		<div class="sf-ar-plan-title">Allocation review — {{ l.amount | currency }} will be applied {{ l.transnos?.length ? 'to the invoices recorded on this line' : 'oldest-first' }}</div>
																		<div *ngIf="!l._plan.plan?.length" class="text-muted small">No open invoice allocation was returned; this receipt will remain on account.</div>
																		<table *ngIf="l._plan.plan?.length" class="table table-sm sf-ar-plan-table">
																			<thead><tr><th>Document</th><th>Date</th><th class="text-right">Balance</th><th class="text-right">Applied</th><th class="text-right">Left open</th></tr></thead>
																			<tbody><tr *ngFor="let p of l._plan.plan">
																				<td><span class="sf-ar-doctag" [class.sf-ar-doctag-credit]="p.kind === 'credit'">{{ p.kind === 'credit' ? 'Credit' : 'Invoice' }}</span> {{ p.transno }}</td>
																				<td>{{ p.trandate | date:'M/d/yy' }}</td>
																				<td class="text-right">{{ (p.kind === 'credit' ? -p.outstanding : p.outstanding) | currency }}</td>
																				<td class="text-right"><strong>{{ p.applied | currency }}</strong></td>
																				<td class="text-right">{{ p.leftOpen ? (p.leftOpen | currency) : 'paid' }}</td>
																			</tr></tbody>
																		</table>
																		<div class="sf-log-review-actions"><button class="btn btn-link btn-sm" (click)="sfLogEdit(l)">Change customer, amount or invoices</button></div>
																	</div>
																</td>
															</tr>
															<!-- Inline edit form — anchored to this row -->
															<tr *ngIf="sfLogIsEditing(l)" class="sf-log-editrow">
																<td colspan="5">
																	<div class="sf-log-draft">
																		<div class="sf-log-draft-head">
																			<strong>Edit money in hand</strong>
																			<span class="text-muted small">Confirm the customer, amount and invoices before posting.</span>
																			<button type="button" class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
																		</div>
																		<div class="sf-log-fields">
																			<label>Customer acct<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.debtorno" placeholder="C00421"></label>
																			<label>Name<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.cust_name" placeholder="as written on the log"></label>
																			<label>Branch<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.branchcode" placeholder="01"></label>
																			<label>Amount<input type="number" step="0.01" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.amount"></label>
																			<label matTooltip="Which ERP payment method the receipt posts under">Tender<select class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.instrument">
																				<option value="check">Check</option>
																				<option value="cash">Cash</option>
																			</select></label>
																			<label matTooltip="Invoice transno(s), comma separated.">Invoices<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.transnosText" placeholder="130306647"></label>
																			<label matTooltip="Open credit notes to consume alongside the check">Credits<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.creditTransnosText" placeholder="optional"></label>
																			<label>Check #<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.check_no"></label>
																			<label matTooltip="The date written on the paper line">Log date<input type="date" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.log_date"></label>
																			<label>Deposit batch<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.deposit_batch" placeholder="2026-07-30"></label>
																			<label class="sf-log-wide">Notes<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.notes"></label>
																		</div>
																		<div class="sf-log-draft-actions">
																			<button class="btn btn-success btn-sm" (click)="sfLogSave()" [disabled]="sfLog.saving">{{ sfLog.saving ? 'Saving…' : 'Save' }}</button>
																			<button class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
																		</div>
																	</div>
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</div>
											<div *ngIf="sfLogByState('keyed').length" class="sf-log-group">
												<div class="sf-log-group-head">
													<span class="sf-log-dot sf-log-dot-wait" aria-hidden="true"></span>
													<strong>Posted — waiting for the money to reach the bank</strong>
													<span class="sf-ar-count">{{ sfLogByState('keyed').length }} · {{ sfLogStateTotal('keyed') | currency }}</span>
												</div>
												<div class="sf-log-note text-muted small">Nothing to do here — each one pairs with its deposit and clears itself<span *ngIf="sfLogAmbiguousCount()">, except the {{ sfLogAmbiguousCount() }} flagged below</span>.</div>
												<table class="table table-sm sf-txns">
													<thead><tr><th>Logged</th><th>Customer</th><th class="text-right">Amount</th><th>Receipt</th><th></th></tr></thead>
													<tbody>
														<ng-container *ngFor="let l of sfLogByState('keyed')">
															<tr [class.sf-log-stale]="l.stale" [class.sf-log-editing]="sfLogIsEditing(l)">
																<td class="small">{{ l.log_date_disp || '—' }}<div *ngIf="l.deposit_batch" class="text-muted">slip {{ l.deposit_batch }}</div></td>
																<td class="sf-desc"><strong>{{ l.cust_name || l.debtorno }}</strong>
																	<span class="sf-log-tender">{{ l.instrument === 'cash' ? 'cash' : 'check' }}<span *ngIf="l.check_no"> #{{ l.check_no }}</span></span>
																	<div *ngIf="sfLogAmbiguous(l)" class="sf-log-warn small" matTooltip="Another logged check is for this same amount, so a deposit at this amount cannot say which one it is. Add the check number or the deposit slip to tell them apart.">⚠ same amount as another logged check — add a check # or slip to tell them apart</div>
																	<div *ngIf="l.stale" class="text-danger small">that invoice was already settled another way</div></td>
																<td class="text-right">{{ l.amount | currency }}</td>
																<td class="small text-muted">#{{ l.posted_transno }}</td>
																<td class="text-nowrap">
																	<button class="btn btn-link btn-sm" (click)="sfLogEdit(l)" [disabled]="sfLogIsEditing(l) || (!!sfLog.draft && !sfLogIsEditing(l))">Edit</button>
																	<button class="btn btn-link btn-sm text-danger" (click)="sfLogDelete(l)" [disabled]="!!sfLog.draft">Void</button>
																</td>
															</tr>
															<!-- Inline edit form for keyed rows -->
															<tr *ngIf="sfLogIsEditing(l)" class="sf-log-editrow">
																<td colspan="5">
																	<div class="sf-log-draft">
																		<div class="sf-log-draft-head">
																			<strong>Edit posted receipt</strong>
																			<span class="text-muted small">Metadata only — the receipt is already posted. Changes to invoices or customer do not re-post.</span>
																			<button type="button" class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
																		</div>
																		<div class="sf-log-fields">
																			<label>Customer acct<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.debtorno" placeholder="C00421"></label>
																			<label>Name<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.cust_name" placeholder="as written on the log"></label>
																			<label>Branch<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.branchcode" placeholder="01"></label>
																			<label>Check #<input type="text" class="form-control form-control-sm sf-log-narrow" [(ngModel)]="sfLog.draft.check_no"></label>
																			<label matTooltip="The date written on the paper line">Log date<input type="date" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.log_date"></label>
																			<label>Deposit batch<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.deposit_batch" placeholder="2026-07-30"></label>
																			<label class="sf-log-wide">Notes<input type="text" class="form-control form-control-sm" [(ngModel)]="sfLog.draft.notes"></label>
																		</div>
																		<div class="sf-log-draft-actions">
																			<button class="btn btn-success btn-sm" (click)="sfLogSave()" [disabled]="sfLog.saving">{{ sfLog.saving ? 'Saving…' : 'Save' }}</button>
																			<button class="btn btn-link btn-sm" (click)="sfLogCancel()" [disabled]="sfLog.saving">Cancel</button>
																		</div>
																	</div>
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</div>
											<div *ngIf="sfLogByState('matched').length" class="sf-log-group">
												<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfLog.doneOpen" (click)="sfLog.doneOpen = !sfLog.doneOpen">
													<span class="sf-log-dot sf-log-dot-done" aria-hidden="true"></span>
													Done — deposit found and reconciled
													<span class="sf-ar-count">{{ sfLogByState('matched').length }} · {{ sfLogStateTotal('matched') | currency }}</span>
													<span class="sf-ar-caret" aria-hidden="true">{{ sfLog.doneOpen ? '▾' : '▸' }}</span>
												</button>
												<table *ngIf="sfLog.doneOpen" class="table table-sm sf-txns">
													<thead><tr><th>Logged</th><th>Customer</th><th class="text-right">Amount</th><th>Receipt</th></tr></thead>
													<tbody>
														<tr *ngFor="let l of sfLogByState('matched')">
															<td class="small">{{ l.log_date_disp || '—' }}</td>
															<td class="sf-desc"><strong>{{ l.cust_name || l.debtorno }}</strong></td>
															<td class="text-right">{{ l.amount | currency }}</td>
															<td class="small text-muted">#{{ l.posted_transno }}</td>
														</tr>
													</tbody>
												</table>
											</div>
											</ng-container>
									</div>

									<div class="sf-ar">
										<div *ngIf="sfAr.message" class="text-danger small">{{ sfAr.message }}</div>
										<div *ngIf="sfAr.loading && !sfAr.loaded" class="text-muted small">Resolving deposits to customers…</div>
										<ng-container *ngIf="sfAr.loaded">
											<!-- Ready: unique customer + exact invoice tie -->
											<div class="sf-ar-tier">
												<div class="sf-ar-tier-head">
													<span class="sf-ar-dot sf-ar-dot-green" aria-hidden="true"></span>
													<strong>Ready — exact invoice match</strong>
													<span class="sf-ar-count">{{ sfAr.ready.length }}<span *ngIf="sfAr.ready.length"> · {{ sfArSum(sfAr.ready) | currency }}</span></span>
													<span class="sf-spacer"></span>
													<button *ngIf="sfAr.ready.length" class="btn btn-sm" [class.btn-success]="sfArSelCount()" [class.btn-outline-secondary]="!sfArSelCount()" (click)="sfArBatchPost()" [disabled]="sfAr.posting || !sfArSelCount()">
														{{ sfAr.posting ? ('Posting ' + sfAr.done + '/' + sfAr.total + '…') : (sfArSelCount() ? ('Create ' + sfArSelCount() + ' payment' + (sfArSelCount() === 1 ? '' : 's')) : 'Create payments') }}
													</button>
												</div>
												<div *ngIf="!sfAr.ready.length" class="text-muted small sf-ar-empty">No exact-match deposits in this range.</div>
												<table *ngIf="sfAr.ready.length" class="table table-sm sf-txns">
											<thead><tr><th><input type="checkbox" [checked]="sfArAllSelected()" [indeterminate]="sfArSomeSelected()" (change)="sfArToggleAll($any($event.target).checked)" [disabled]="sfAr.posting || !sfArSelectableCount()" [matTooltip]="sfArSelectableCount() ? 'Select all / none — skips rows needing a payer check' : 'Nothing here can be bulk-selected — each row needs a payer check'"></th><th>Date</th><th>Payer → Customer</th><th>Allocation</th><th class="text-right">Amount</th><th></th><th *ngIf="sfArAnyStatus(sfAr.ready)">Status</th></tr></thead>
											<tbody>
												<ng-container *ngFor="let r of sfAr.ready">
												<tr [class.sf-ar-ready-detailing]="r._detailsOpen">
													<td><input type="checkbox" [(ngModel)]="r._sel" [disabled]="sfAr.posting || r._posted" [attr.aria-label]="'Select deposit ' + (r.amount | currency) + ' for ' + (r.customer?.name || 'customer')"></td>
													<td>{{ r.posted }}</td>
													<td class="sf-desc"><span [class.sf-ar-nopayer]="!r.payer">{{ r.payer || 'no payer name' }}</span> <span class="sf-ar-arrow">→</span> <strong>{{ r.customer?.name }}</strong> <span *ngIf="r.via === 'alias'" class="sf-ar-via" matTooltip="Learned from a previous confirmation">known payer</span><span *ngIf="r.payer_unconfirmed" class="sf-ar-via sf-ar-via-amt" matTooltip="Matched by exact invoice amount only — the bank payer name did not resolve. Verify this is the right customer, then tick it yourself; bulk select skips it.">verify payer</span></td>
													<td class="small">{{ r.tie?.reason }}</td>
													<td class="text-right">{{ r.amount | currency }}</td>
													<td class="text-nowrap"><button type="button" class="btn btn-link btn-sm" (click)="sfArToggleReadyDetails(r)" [attr.aria-expanded]="!!r._detailsOpen">{{ r._detailsOpen ? 'Hide details' : 'Details' }}</button></td>
													<td *ngIf="sfArAnyStatus(sfAr.ready)" class="small" [class.text-danger]="(r._status || '').startsWith('failed')">{{ r._status }}</td>
												</tr>
												<tr *ngIf="r._detailsOpen" class="sf-ar-ready-details">
													<td [attr.colspan]="sfArAnyStatus(sfAr.ready) ? 7 : 6">
														<div class="sf-ar-ready-detail-grid">
															<div><small>Bank account</small><strong>{{ sfBankLabel(r.erp_bankact) }}</strong><span class="text-muted">{{ r.erp_bankact }}</span></div>
															<div><small>Bank line</small><strong>{{ r.description || 'No bank description supplied' }}</strong></div>
															<div><small>Customer account</small><strong>{{ r.customer?.name }}</strong><span class="text-muted">Customer {{ r.customer?.debtorno }} · branch {{ r.customer?.branchcode }}</span></div>
														</div>
														<table *ngIf="r.tie?.docs?.length" class="table table-sm sf-ar-ready-docs">
															<thead><tr><th>Document</th><th>Order</th><th class="text-right">Open balance</th></tr></thead>
															<tbody><tr *ngFor="let d of r.tie.docs"><td><span class="sf-ar-doctag" [class.sf-ar-doctag-credit]="d.credit">{{ d.credit ? 'Credit' : 'Invoice' }}</span> {{ d.transno }}</td><td>{{ d.order || '—' }}</td><td class="text-right">{{ (d.credit ? -d.outstanding : d.outstanding) | currency }}</td></tr></tbody>
														</table>
														<div *ngIf="!r.tie?.docs?.length" class="text-muted small">No document detail returned for this proposal. Refresh proposals and try again.</div>
													</td>
												</tr>
												</ng-container>
											</tbody>
												</table>
											</div>
											<!-- Review: customer known, no exact tie — one-click oldest-first -->
											<div class="sf-ar-tier">
												<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfAr.reviewOpen" (click)="sfAr.reviewOpen = !sfAr.reviewOpen">
													<span class="sf-ar-dot sf-ar-dot-amber" aria-hidden="true"></span>
													Partial payment — applies to open invoices <span class="sf-ar-count">{{ sfAr.review.length }}<span *ngIf="sfAr.review.length"> · {{ sfArSum(sfAr.review) | currency }}</span></span> <span class="sf-ar-caret" aria-hidden="true">{{ sfAr.reviewOpen ? '▾' : '▸' }}</span>
												</button>
												<table *ngIf="sfAr.reviewOpen && sfAr.review.length" class="table table-sm sf-txns">
													<thead><tr><th>Date</th><th>Payer → Customer</th><th class="text-right">Open AR</th><th class="text-right">Amount</th><th></th><th *ngIf="sfArAnyStatus(sfAr.review)">Status</th></tr></thead>
													<tbody>
														<ng-container *ngFor="let r of sfAr.review">
															<tr>
																<td>{{ r.posted }}</td>
																<td class="sf-desc"><span [class.sf-ar-nopayer]="!r.payer">{{ r.payer || 'no payer name' }}</span> <span class="sf-ar-arrow">→</span> <strong>{{ r.customer?.name }}</strong> <span *ngIf="r.via === 'alias'" class="sf-ar-via" matTooltip="Learned from a previous confirmation">known payer</span><span *ngIf="r.payer_unconfirmed" class="sf-ar-via sf-ar-via-amt" matTooltip="Matched by exact invoice amount only — the bank payer name did not resolve. Verify this is the right customer before posting.">verify payer</span></td>
																<td class="text-right small">{{ r.customer?.openCount }} inv · {{ r.customer?.openTotal | currency }}<span *ngIf="r.customer?.openCreditCount" class="sf-ar-credit-note" [matTooltip]="r.customer.openCreditCount + ' open credit note(s) — applied automatically when posting'"> · {{ r.customer.openCreditTotal | currency }} cr</span><span *ngIf="r.overBalance" class="sf-ar-over" matTooltip="Deposit exceeds the open balance — the excess posts on account (customer credit)."> · over bal</span></td>
																<td class="text-right">{{ r.amount | currency }}</td>
																<td class="text-nowrap">
																	<button class="btn btn-link btn-sm" (click)="sfArPreview(r)" [disabled]="r._planLoading">{{ r._plan ? 'Hide' : (r._planLoading ? '…' : 'Preview') }}</button>
																	<button class="btn btn-outline-secondary btn-sm" (click)="sfArPostReview(r)" [disabled]="r._posted || sfAr.posting || r._planLoading">{{ sfArHasPick(r) ? 'Post to selected' : 'Post oldest-first' }}</button>
																</td>
																<td *ngIf="sfArAnyStatus(sfAr.review)" class="small" [class.text-danger]="(r._status || '').startsWith('failed')">{{ r._status }}</td>
															</tr>
															<tr *ngIf="r._plan || r._receipts?.length" class="sf-ar-planrow">
																<td [attr.colspan]="sfArAnyStatus(sfAr.review) ? 6 : 5">
																	<div class="sf-ar-plan-wrap">
																		<div *ngIf="r._receipts?.length" class="sf-ar-match-block">
																			<div class="sf-ar-plan-title">Already posted — match this deposit <span class="text-muted">(do not create another receipt)</span></div>
																			<table class="table table-sm sf-ar-plan-table">
																				<thead><tr><th>Receipt</th><th>Date</th><th class="text-right">Amount</th><th></th></tr></thead>
																				<tbody>
																					<tr *ngFor="let rec of r._receipts" [class.sf-ar-plan-picked]="rec.exactAmount">
																						<td><span class="sf-ar-doctag">Receipt</span> {{ rec.transno }}<span *ngIf="rec.ref" class="text-muted small"> · {{ rec.ref }}</span></td>
																						<td>{{ rec.trandate | date:'M/d/yy' }}</td>
																						<td class="text-right">{{ rec.amount | currency }} <span *ngIf="rec.exactAmount" class="sf-ar-via">exact</span></td>
																						<td class="text-nowrap"><button type="button" class="btn btn-sm" [class.btn-success]="rec.exactAmount" [class.btn-outline-secondary]="!rec.exactAmount" (click)="sfArMatchExisting(r, rec)" [disabled]="r._posted || sfAr.posting">{{ r._posted ? 'Matched' : 'Match' }}</button></td>
																					</tr>
																				</tbody>
																			</table>
																		</div>
																		<div class="sf-ar-plan-title">{{ r._receipts?.length ? 'Or post a new receipt — ' : '' }}Allocation preview — {{ r.amount | currency }} applied {{ sfArHasPick(r) ? 'to the documents you picked' : 'oldest-first' }}</div>
																		<div class="sf-ar-plan-mode">
																			<span *ngIf="!sfArHasPick(r) && !sfArCreditOnlyPick(r)" class="text-muted">Tick a document to allocate there instead of oldest-first.</span>
																			<span *ngIf="sfArCreditOnlyPick(r)" class="sf-ar-plan-hint">Credit ticked — also tick an invoice for it to apply against, or the plan stays oldest-first.</span>
																			<span *ngIf="sfArHasPick(r)"><strong>{{ sfArPickedCount(r) }}</strong> picked — the deposit spreads across them oldest-first; anything left over posts on account.</span>
																			<button *ngIf="sfArHasPick(r)" class="btn btn-link btn-sm sf-ar-plan-reset" (click)="sfArPickReset(r)" [disabled]="r._planLoading">Reset to oldest-first</button>
																			<span *ngIf="r._planLoading" class="text-muted sf-ar-plan-busy">recalculating…</span>
																		</div>
																		<table *ngIf="r._view?.length" class="table table-sm sf-ar-plan-table">
																			<thead><tr><th class="sf-ar-plan-pickcol">Pick</th><th>Document</th><th>Date</th><th class="text-right">Balance</th><th class="text-right">Applied</th><th class="text-right">Left open</th></tr></thead>
																			<tbody>
																				<tr *ngFor="let p of r._view" [class.sf-ar-plan-untouched]="!p.applied" [class.sf-ar-plan-creditrow]="p.kind === 'credit'" [class.sf-ar-plan-picked]="sfArIsPicked(r, p)">
																					<td class="sf-ar-plan-pickcol"><mat-checkbox [checked]="sfArIsPicked(r, p)" [disabled]="r._planLoading || r._posted" (change)="sfArTogglePick(r, p)" [attr.aria-label]="'Allocate this deposit to ' + (p.kind === 'credit' ? 'credit ' : 'invoice ') + p.transno"></mat-checkbox></td>
																					<td><span class="sf-ar-doctag" [class.sf-ar-doctag-credit]="p.kind === 'credit'">{{ p.kind === 'credit' ? 'Credit' : 'Invoice' }}</span> {{ p.transno }}</td>
																					<td>{{ p.trandate | date:'M/d/yy' }}</td>
																					<td class="text-right">{{ (p.kind === 'credit' ? -p.outstanding : p.outstanding) | currency }}</td>
																					<td class="text-right"><strong *ngIf="p.applied">{{ p.applied | currency }}</strong><span *ngIf="!p.applied" class="text-muted">—</span></td>
																					<td class="text-right" [class.text-success]="!p.leftOpen">{{ p.leftOpen ? (p.leftOpen | currency) : 'paid' }}</td>
																				</tr>
																			</tbody>
																			<tfoot *ngIf="r._plan">
																				<tr class="sf-ar-plan-foot">
																					<td colspan="4" class="text-right">Cleared on invoices</td>
																					<td class="text-right"><strong>{{ r._plan.invoiceApplied | currency }}</strong></td>
																					<td></td>
																				</tr>
																				<tr *ngIf="r._plan.creditApplied > 0" class="sf-ar-plan-foot">
																					<td colspan="4" class="text-right">…funded by credit notes</td>
																					<td class="text-right sf-ar-credit-note">{{ -r._plan.creditApplied | currency }}</td>
																					<td></td>
																				</tr>
																				<tr *ngIf="r._plan.onAccount > 0" class="sf-ar-plan-foot">
																					<td colspan="4" class="text-right">Deposit left on account (unapplied)</td>
																					<td class="text-right sf-ar-onacct-amt">{{ r._plan.onAccount | currency }}</td>
																					<td></td>
																				</tr>
																			</tfoot>
																		</table>
																	</div>
																</td>
															</tr>
															</ng-container>
													</tbody>
												</table>
											</div>
											<!-- Attention: resolved but likely already recorded / can't allocate — never bulk-post -->
											<div class="sf-ar-tier" *ngIf="sfAr.attention.length">
												<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfAr.attentionOpen" (click)="sfAr.attentionOpen = !sfAr.attentionOpen">
													<span class="sf-ar-dot sf-ar-dot-attn" aria-hidden="true"></span>
													Needs a look — likely already recorded or over balance <span class="sf-ar-count">{{ sfAr.attention.length }} · {{ sfArSum(sfAr.attention) | currency }}</span> <span class="sf-ar-caret" aria-hidden="true">{{ sfAr.attentionOpen ? '▾' : '▸' }}</span>
												</button>
												<!-- Bulk PAIRING is safe here even though bulk posting never is: the check log
												     named each pairing, so nothing is guessed and no receipt is created. -->
												<div *ngIf="sfArExpectedPending().length" class="sf-log-bar">
													<span class="text-muted small">{{ sfArExpectedPending().length }} already have a receipt keyed from the check log — pairing clears them too.</span>
													<span class="sf-spacer"></span>
													<button class="btn btn-success btn-sm" (click)="sfArResolveAllExpected()" [disabled]="sfAr.resolving"
															matTooltip="Pair every check-log deposit with the receipt already keyed for it, and clear those receipts. No receipts are created.">
														{{ sfAr.resolving
															? ('Pairing ' + sfAr.resolveDone + '/' + sfAr.resolveTotal + '…')
															: ('Match all ' + sfArExpectedPending().length + ' from the check log · ' + (sfArSum(sfArExpectedPending()) | currency)) }}
													</button>
												</div>
												<!-- Same reasoning, different evidence: the receipt quotes this bank line in
												     its own GL narrative, so the pairing is on the record, not inferred. -->
												<div *ngIf="sfArReceiptLinkPending().length" class="sf-log-bar">
													<span class="text-muted small">{{ sfArReceiptLinkPending().length }} already have a receipt posted from that very deposit — pairing clears them too.</span>
													<span class="sf-spacer"></span>
													<button class="btn btn-success btn-sm" (click)="sfArLinkAllReceipts()" [disabled]="sfAr.resolving"
															matTooltip="Pair every deposit whose receipt names it in the GL narrative, and clear those receipts. No receipts are created.">
														{{ sfAr.resolving
															? ('Pairing ' + sfAr.resolveDone + '/' + sfAr.resolveTotal + '…')
															: ('Match all ' + sfArReceiptLinkPending().length + ' to their receipts · ' + (sfArSum(sfArReceiptLinkPending()) | currency)) }}
													</button>
												</div>
												<table *ngIf="sfAr.attentionOpen" class="table table-sm sf-txns">
													<thead><tr><th>Date</th><th>Payer → Customer</th><th>Why</th><th class="text-right">Open AR</th><th class="text-right">Amount</th><th></th></tr></thead>
													<tbody>
														<tr *ngFor="let r of sfAr.attention" [class.sf-ar-fromlog]="r.attention === 'expected_keyed'">
															<td>{{ r.posted }}</td>
															<td class="sf-desc"><span [class.sf-ar-nopayer]="!r.payer">{{ r.payer || 'no payer name' }}</span> <span class="sf-ar-arrow">→</span> <strong>{{ r.customer?.name }}</strong> <span *ngIf="r.via === 'expected'" class="sf-ar-via sf-ar-via-log" matTooltip="Identified from the check log, not the bank payer name">check log</span></td>
															<td class="small sf-ar-attn-msg">{{ r.attentionMsg }}</td>
															<td class="text-right small">{{ r.customer?.openCount }} inv · {{ r.customer?.openTotal | currency }}</td>
															<td class="text-right">{{ r.amount | currency }}</td>
															<!-- The receipt already exists, so the only correct action is to pair this deposit
												     to it. Posting again would double-count the money. -->
												<td class="text-nowrap">
													<button *ngIf="r.expectedResolve" class="btn btn-outline-secondary btn-sm" (click)="sfArResolveExpected(r)" [disabled]="r._posted" matTooltip="Pair this deposit with the receipt already keyed from the check log">{{ r._posted ? 'Matched' : 'Match to receipt' }}</button>
													<button *ngIf="!r.expectedResolve && r.receiptLink" class="btn btn-outline-secondary btn-sm" (click)="sfArLinkReceipt(r)" [disabled]="r._posted" matTooltip="Pair this deposit with receipt #{{ r.receiptLink.transno }}, which was posted from it — its GL narrative names this bank line">{{ r._posted ? 'Matched' : 'Match to receipt' }}</button>
													<button *ngIf="!r.expectedResolve" class="btn btn-link btn-sm" (click)="sfArOpenDrawer(r, r.customer?.name)">Open…</button>
													<span *ngIf="r._status" class="small" [class.text-danger]="(r._status || '').startsWith('failed')">{{ r._status }}</span>
												</td>
														</tr>
													</tbody>
												</table>
											</div>
											<!-- Unresolved: no payer name — manual with suggestions -->
											<div class="sf-ar-tier">
												<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfAr.unresolvedOpen" (click)="sfAr.unresolvedOpen = !sfAr.unresolvedOpen">
													<span class="sf-ar-dot sf-ar-dot-grey" aria-hidden="true"></span>
													Not matched to a customer — match an old receipt or post <span class="sf-ar-count">{{ sfAr.unresolved.length }}<span *ngIf="sfAr.unresolved.length"> · {{ sfArSum(sfAr.unresolved) | currency }}</span></span> <span class="sf-ar-caret" aria-hidden="true">{{ sfAr.unresolvedOpen ? '▾' : '▸' }}</span>
												</button>
												<table *ngIf="sfAr.unresolvedOpen && sfAr.unresolved.length" class="table table-sm sf-txns">
													<thead><tr><th>Date</th><th>Payer on the deposit</th><th>Next step</th><th class="text-right">Amount</th><th></th></tr></thead>
													<tbody>
														<ng-container *ngFor="let r of sfAr.unresolved">
															<tr>
																<td>{{ r.posted }}</td>
																<td class="sf-desc" [matTooltip]="r.description">{{ sfArDepositLabel(r) }}</td>
																<!-- Names alone are no basis for moving money: the candidates expand inline
																     with account, the tying invoice and their open AR — the same read-before-you-post
																     shape the partial-payment tier uses for its allocation preview. -->
																<td class="text-nowrap">
																	<button *ngIf="sfArPayerName(r)" type="button" class="btn btn-link btn-sm" (click)="sfArOpenDrawer(r, sfArPayerName(r))" matTooltip="Opens a receipt and searches customers for this payer. If the full ACH name finds nothing — common when the account is on file under a DBA — the search narrows word by word automatically.">Search this payer</button>
																	<button *ngIf="sfArSugCount(r)" type="button" class="btn btn-link btn-sm" (click)="sfArSugTogglePanel(r)" [attr.aria-expanded]="!!r._sugOpen">{{ r._sugOpen ? 'Hide' : (sfArSugCount(r) + ' possible customer' + (sfArSugCount(r) === 1 ? '' : 's')) }}</button>
																	<span *ngIf="!sfArPayerName(r) && !sfArSugCount(r)" class="text-muted small">identify from the deposit slip</span>
																</td>
																<td class="text-right">{{ r.amount | currency }}</td>
																<td class="text-nowrap">
																	<button class="btn btn-outline-secondary btn-sm" (click)="sfArOpenDrawer(r)" [disabled]="r._posted">Post receipt…</button>
																	<span *ngIf="r._status" class="small" [class.text-danger]="(r._status || '').startsWith('failed')">{{ r._status }}</span>
																</td>
															</tr>
															<tr *ngIf="r._sugOpen" class="sf-ar-planrow">
																<td colspan="5">
																	<div class="sf-ar-plan-wrap sf-ar-sug-wrap">
																		<div class="sf-ar-plan-title">Possible customers for {{ r.amount | currency }} — expand one to match an existing receipt or post a new one</div>
																		<table class="table table-sm sf-ar-plan-table">
																			<thead><tr><th>Customer</th><th>Account</th><th>Tying invoice</th><th class="text-right">Invoice balance</th><th class="text-right">Their open AR</th><th></th></tr></thead>
																			<tbody>
																				<ng-container *ngFor="let s of sfArSugList(r)">
																				<tr [class.sf-ar-plan-picked]="sfArSugIsOpen(r, s)">
																					<td><strong>{{ s.name }}</strong></td>
																					<td class="small">{{ s.debtorno }}<span *ngIf="s.branchcode && s.branchcode !== '00' && s.branchcode !== '0'" class="text-muted"> · br {{ s.branchcode }}</span></td>
																					<td class="small"><span *ngIf="s.exact"><span class="sf-ar-doctag">Invoice</span> {{ s.transno }}<span *ngIf="s.order" class="text-muted"> · order {{ s.order }}</span></span><span *ngIf="!s.exact" class="text-muted">payer-name match only</span></td>
																					<td class="text-right">{{ s.exact ? (s.out | currency) : '—' }}</td>
																					<td class="text-right small"><span *ngIf="s.openCount">{{ s.openCount }} inv · {{ s.openTotal | currency }}</span><span *ngIf="!s.openCount" class="text-muted">—</span></td>
																					<td class="text-nowrap">
																						<button type="button" class="btn btn-outline-secondary btn-sm" (click)="sfArSugShowInvoices(r, s)" [disabled]="r._posted || r._planLoading || sfAr.posting">{{ sfArSugIsOpen(r, s) ? 'Hide invoices' : (s.openCount ? 'Invoices' : 'Open AR') }}</button>
																						<button type="button" class="btn btn-link btn-sm" (click)="sfArOpenDrawer(r, s.name)" [disabled]="r._posted">Drawer…</button>
																					</td>
																				</tr>
																				<tr *ngIf="sfArSugIsOpen(r, s)" class="sf-ar-sug-alloc">
																					<td colspan="6">
																						<div *ngIf="r._receipts?.length" class="sf-ar-match-block">
																							<div class="sf-ar-plan-title">Already posted — match this deposit <span class="text-muted">(do not create another receipt)</span></div>
																							<table class="table table-sm sf-ar-plan-table">
																								<thead><tr><th>Receipt</th><th>Date</th><th class="text-right">Amount</th><th></th></tr></thead>
																								<tbody>
																									<tr *ngFor="let rec of r._receipts" [class.sf-ar-plan-picked]="rec.exactAmount">
																										<td><span class="sf-ar-doctag">Receipt</span> {{ rec.transno }}<span *ngIf="rec.ref" class="text-muted small"> · {{ rec.ref }}</span></td>
																										<td>{{ rec.trandate | date:'M/d/yy' }}</td>
																										<td class="text-right">{{ rec.amount | currency }} <span *ngIf="rec.exactAmount" class="sf-ar-via">exact</span></td>
																										<td class="text-nowrap"><button type="button" class="btn btn-sm" [class.btn-success]="rec.exactAmount" [class.btn-outline-secondary]="!rec.exactAmount" (click)="sfArMatchExisting(r, rec)" [disabled]="r._posted || sfAr.posting">{{ r._posted ? 'Matched' : 'Match' }}</button></td>
																									</tr>
																								</tbody>
																							</table>
																						</div>
																						<div class="sf-ar-plan-title">{{ r._receipts?.length ? 'Or post a new receipt' : 'Open invoices' }}</div>
																						<div class="sf-ar-plan-mode">
																							<span *ngIf="!sfArHasPick(r) && !sfArCreditOnlyPick(r)" class="text-muted">Tick a document to allocate there instead of oldest-first.</span>
																							<span *ngIf="sfArCreditOnlyPick(r)" class="sf-ar-plan-hint">Credit ticked — also tick an invoice for it to apply against, or the plan stays oldest-first.</span>
																							<span *ngIf="sfArHasPick(r)"><strong>{{ sfArPickedCount(r) }}</strong> picked — the deposit spreads across them oldest-first; anything left over posts on account.</span>
																							<button *ngIf="sfArHasPick(r)" class="btn btn-link btn-sm sf-ar-plan-reset" (click)="sfArPickReset(r)" [disabled]="r._planLoading">Reset to oldest-first</button>
																							<span class="sf-spacer"></span>
																							<button class="btn btn-outline-secondary btn-sm" (click)="sfArPostReview(r)" [disabled]="r._posted || sfAr.posting || r._planLoading || !r._plan">{{ sfArHasPick(r) ? 'Post to selected' : 'Post oldest-first' }}</button>
																							<span *ngIf="r._planLoading" class="text-muted sf-ar-plan-busy">loading…</span>
																						</div>
																						<table *ngIf="r._view?.length" class="table table-sm sf-ar-plan-table">
																							<thead><tr><th class="sf-ar-plan-pickcol">Pick</th><th>Document</th><th>Date</th><th class="text-right">Balance</th><th class="text-right">Applied</th><th class="text-right">Left open</th></tr></thead>
																							<tbody>
																								<tr *ngFor="let p of r._view" [class.sf-ar-plan-untouched]="!p.applied" [class.sf-ar-plan-creditrow]="p.kind === 'credit'" [class.sf-ar-plan-picked]="sfArIsPicked(r, p)">
																									<td class="sf-ar-plan-pickcol"><mat-checkbox [checked]="sfArIsPicked(r, p)" [disabled]="r._planLoading || r._posted" (change)="sfArTogglePick(r, p)" [attr.aria-label]="'Allocate this deposit to ' + (p.kind === 'credit' ? 'credit ' : 'invoice ') + p.transno"></mat-checkbox></td>
																									<td><span class="sf-ar-doctag" [class.sf-ar-doctag-credit]="p.kind === 'credit'">{{ p.kind === 'credit' ? 'Credit' : 'Invoice' }}</span> {{ p.transno }}</td>
																									<td>{{ p.trandate | date:'M/d/yy' }}</td>
																									<td class="text-right">{{ (p.kind === 'credit' ? -p.outstanding : p.outstanding) | currency }}</td>
																									<td class="text-right"><strong *ngIf="p.applied">{{ p.applied | currency }}</strong><span *ngIf="!p.applied" class="text-muted">—</span></td>
																									<td class="text-right" [class.text-success]="!p.leftOpen">{{ p.leftOpen ? (p.leftOpen | currency) : 'paid' }}</td>
																								</tr>
																							</tbody>
																							<tfoot *ngIf="r._plan">
																								<tr class="sf-ar-plan-foot">
																									<td colspan="4" class="text-right">Cleared on invoices</td>
																									<td class="text-right"><strong>{{ r._plan.invoiceApplied | currency }}</strong></td>
																									<td></td>
																								</tr>
																								<tr *ngIf="r._plan.creditApplied > 0" class="sf-ar-plan-foot">
																									<td colspan="4" class="text-right">…funded by credit notes</td>
																									<td class="text-right sf-ar-credit-note">{{ -r._plan.creditApplied | currency }}</td>
																									<td></td>
																								</tr>
																								<tr *ngIf="r._plan.onAccount > 0" class="sf-ar-plan-foot">
																									<td colspan="4" class="text-right">Deposit left on account (unapplied)</td>
																									<td class="text-right sf-ar-onacct-amt">{{ r._plan.onAccount | currency }}</td>
																									<td></td>
																								</tr>
																							</tfoot>
																						</table>
																						<div *ngIf="!r._planLoading && !r._receipts?.length && r._plan && !r._view?.length" class="text-muted small">No open invoices and no unmatched receipts on this account — posting would land the full deposit on account.</div>
																						<div *ngIf="!r._planLoading && r._receipts?.length && !r._view?.length" class="text-muted small sf-ar-plan-note">No open invoices — if none of the receipts above are this deposit, posting would land it on account.</div>
																					</td>
																				</tr>
																				</ng-container>
																			</tbody>
																		</table>
																		<div class="sf-ar-plan-note">Exact amount ties are pre-selected when you open invoices — change the ticks or pick another customer before posting.</div>
																	</div>
																</td>
															</tr>
															</ng-container>
													</tbody>
												</table>
											</div>
											</ng-container>

											<!-- Not customer money: interest, own-account transfers, adjustments,
											     returned items. Held here so the total still reconciles, but kept
											     out of the manual AR list nobody could clear them from. -->
											<div class="sf-ar-tier" *ngIf="sfAr.nonCustomer?.length">
												<button class="btn btn-link btn-sm sf-ar-toggle" [attr.aria-expanded]="sfAr.nonCustomerOpen" (click)="sfAr.nonCustomerOpen = !sfAr.nonCustomerOpen">
													Not customer money — journal, don't receipt <span class="sf-ar-count">{{ sfAr.nonCustomer.length }} · {{ sfArSum(sfAr.nonCustomer) | currency }}</span> <span class="sf-ar-caret" aria-hidden="true">{{ sfAr.nonCustomerOpen ? '▾' : '▸' }}</span>
												</button>
												<table *ngIf="sfAr.nonCustomerOpen" class="table table-sm sf-txns">
													<thead><tr><th>Date</th><th>Bank line</th><th>Why it's here</th><th class="text-right">Amount</th></tr></thead>
													<tbody>
														<tr *ngFor="let r of sfAr.nonCustomer">
															<td>{{ r.posted }}</td>
															<td class="sf-desc" [matTooltip]="r.description">{{ r.description }}</td>
															<td class="small text-muted">{{ r.nonCustomer }}</td>
															<td class="text-right">{{ r.amount | currency }}</td>
														</tr>
													</tbody>
												</table>
											</div>
									</div>
									<div *ngIf="sf.message" class="sf-msg">{{ sf.message }}</div>
									<ng-container *ngTemplateOutlet="sfReceiptDrawerTpl"></ng-container>
								</div>
							</div><!-- /ar tabpane -->

							<!-- Shared money-in receipt drawer (rendered in Integrations and AR receipts) -->
							<ng-template #sfReceiptDrawerTpl>
										<!-- Money-in drawer: post a customer receipt for an unmatched deposit. -->
										<div class="sf-post-drawer" *ngIf="sfReceiptRow">
											<div class="sf-post-head">
												<span class="sf-post-head-icon sf-post-head-icon--in"><mat-icon>south_west</mat-icon></span>
												<div class="sf-post-head-text">
													<strong>Post customer receipt</strong>
													<div class="sf-post-context">
														<span class="sf-post-context-date">{{ sfReceiptRow.posted }}</span>
														<span class="sf-post-context-desc" [matTooltip]="sfReceiptRow.description">{{ sfReceiptRow.description }}</span>
													</div>
												</div>
												<span class="sf-post-amount sf-post-amount--in">{{ sfReceiptRow.amount | currency }}</span>
												<button type="button" class="sf-post-close" aria-label="Close" (click)="sfCloseReceipt()"><mat-icon>close</mat-icon></button>
											</div>

											<div class="sf-post-find" *ngIf="!sfReceiptCustomer">
												<div class="sf-post-step-head">
													<h6>Who paid?</h6>
													<span>Find the customer this deposit belongs to — matching open invoices are allocated automatically.</span>
												</div>
												<div class="sf-post-search-row">
													<div class="sf-post-search-input">
														<mat-icon>search</mat-icon>
														<input type="search" [(ngModel)]="sfReceiptSearch" [ngModelOptions]="{standalone:true}" (keyup.enter)="sfSearchReceiptCustomers()" placeholder="Customer name or number" aria-label="Search customers">
													</div>
													<button type="button" class="btn btn-primary" (click)="sfSearchReceiptCustomers()">Search</button>
												</div>
												<div *ngIf="sfReceiptLoading" class="sf-post-empty sf-post-searching">
													<span class="sf-search-spinner"></span>
													Searching customers…
												</div>
												<div *ngIf="!sfReceiptLoading && sfReceiptSearch && !sfReceiptResults.length" class="sf-post-empty">
													<mat-icon>person_search</mat-icon>
													<div>No customers matched &ldquo;{{ sfReceiptSearch }}&rdquo; — try fewer words.</div>
												</div>
												<div class="sf-result-list" *ngIf="!sfReceiptLoading && sfReceiptResults.length">
													<div class="sf-result-count">{{ sfReceiptResults.length }} customer{{ sfReceiptResults.length === 1 ? '' : 's' }} found<span *ngIf="sfReceiptSearchFallback" class="text-muted"> — nothing matched the full payer, so this searched &ldquo;{{ sfReceiptSearchFallback }}&rdquo;</span></div>
													<button type="button" class="sf-result" *ngFor="let c of sfReceiptResults" (click)="sfSelectReceiptCustomer(c)">
														<span class="sf-result-avatar sf-result-avatar--customer">{{ (c.name || '?').charAt(0) | uppercase }}</span>
														<span class="sf-result-main">
															<strong>{{ c.name }}</strong>
															<small><span class="sf-result-id">{{ c.debtorno }}<ng-container *ngIf="c.branchcode">.{{ c.branchcode }}</ng-container></span><span *ngIf="c.address3" class="sf-result-meta">{{ c.address3 }}<ng-container *ngIf="c.address4">, {{ c.address4 }}</ng-container></span></small>
														</span>
														<span class="sf-result-balance" *ngIf="c.aged?.balance != null">Balance {{ c.aged.balance | currency }}</span>
														<mat-icon class="sf-result-go">chevron_right</mat-icon>
													</button>
												</div>
											</div>

											<div *ngIf="sfReceiptCustomer">
												<div class="sf-post-tabs">
													<div class="sf-post-identity sf-post-identity--lead">
														<span class="sf-result-avatar sf-result-avatar--customer">{{ (sfReceiptCustomer.name || '?').charAt(0) | uppercase }}</span>
														<span class="sf-post-identity-text">
															<strong>{{ sfReceiptCustomer.name }}</strong>
															<small>{{ sfReceiptCustomer.debtorno }}<ng-container *ngIf="sfReceiptCustomer.branchcode">.{{ sfReceiptCustomer.branchcode }}</ng-container><ng-container *ngIf="sfReceiptAr?.aged"> · balance {{ sfReceiptAr.aged.balance | currency }}</ng-container></small>
														</span>
													</div>
													<button type="button" class="sf-post-identity-change" (click)="sfReceiptCustomer = null; sfReceiptAr = null;">Change customer</button>
												</div>
												<div class="sf-post-note">
													<mat-icon>info</mat-icon>
													<span>Records {{ sfReceiptRow.amount | currency }} received on {{ sfReceiptRow.posted }} into {{ sfBankLabel(selectedBankAccount.value) }}.
													Matching open invoice(s) are allocated automatically; the bank line is matched once posted. No card is charged.</span>
												</div>
												<div class="sf-receipt-form">
													<label><span>Payment type</span>
														<select class="form-control" [(ngModel)]="sfReceiptPaymentType" [ngModelOptions]="{standalone:true}">
															<option *ngFor="let m of payment_methods" [value]="m.paymentid">{{ m.paymentname }}</option>
														</select>
													</label>
													<label><span>Reference</span>
														<input class="form-control" type="text" [(ngModel)]="sfReceiptReference" [ngModelOptions]="{standalone:true}" maxlength="50">
													</label>
													<div class="sf-receipt-actions">
														<a class="btn btn-outline-secondary" [href]="'#/receivables/payment-entry/' + sfReceiptCustomer.debtorno + '/' + (sfReceiptCustomer.branchcode || '00')" target="_blank" rel="noopener" matTooltip="Complex split/discount allocation — opens full Payment Entry in a new tab">Full payment entry ↗</a>
														<button type="button" class="btn btn-success sf-receipt-post-btn" (click)="sfSubmitReceipt()" [disabled]="sfReceiptSubmitting">
															<span *ngIf="sfReceiptSubmitting" class="sf-search-spinner sf-search-spinner--btn"></span>
															{{ sfReceiptSubmitting ? 'Posting…' : ('Post ' + (sfReceiptRow.amount | currency) + ' receipt') }}
														</button>
													</div>
												</div>
											</div>
										</div>
							</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
